
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("6M71K", function(module, exports) {
/**
 * @generated SignedSource<<4c021c6a1ed1e30b20e3b67fb4ea22e8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ecbb6e526a968754$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ConfluenceSmartCardProviderConsolidatedSmartCardProviderWriteFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "Content"
};
$ecbb6e526a968754$var$node.hash = "f4093e7916c35c0c1b9141fd35c3dbe3";
var $ecbb6e526a968754$export$2e2bcd8739ae039 = $ecbb6e526a968754$var$node;


/**
 * @generated SignedSource<<69adaaa975d3bb98285d89324cde2376>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2114907496ee9554$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ConfluenceSmartCardProviderConsolidatedSmartCardProviderReadFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "Content"
};
$2114907496ee9554$var$node.hash = "3fd9bcac35b412a193a9c2f2d5df8b3c";
var $2114907496ee9554$export$2e2bcd8739ae039 = $2114907496ee9554$var$node;


/**
 * @generated SignedSource<<6f1560a1e596d5aeac087b552ac1fdc2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $896ad30c32f2cdd3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ConfluenceSmartCardProviderCurrentSmartCardProviderWriteFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "Content"
};
$896ad30c32f2cdd3$var$node.hash = "05d2a2275047024b0d469ae534b88e41";
var $896ad30c32f2cdd3$export$2e2bcd8739ae039 = $896ad30c32f2cdd3$var$node;


/**
 * @generated SignedSource<<bbec80b8d7ffb4e36b6143c20c7fdacc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5fd779f9cf97f4fb$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ConfluenceSmartCardProviderCurrentSmartCardProviderReadFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "Content"
};
$5fd779f9cf97f4fb$var$node.hash = "24af67d646910e1784019b6a037f34e4";
var $5fd779f9cf97f4fb$export$2e2bcd8739ae039 = $5fd779f9cf97f4fb$var$node;



var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $7bZ3i = parcelRequire("7bZ3i");


var $a2xFu = parcelRequire("a2xFu");

const $89aa0ef6b16bedeb$var$ATLASSIAN_DOMAINS = [
    '.atlassian.com',
    '.atlassian.net',
    '.jira-dev.com',
    '.jira.com',
    '.atlassian-stg-fedm.net',
    '.atlassian-us-gov-mod.net',
    '.atlassian-us-gov-mod.com'
];
const $89aa0ef6b16bedeb$export$97f4c254b641e719 = (hostname)=>!$89aa0ef6b16bedeb$var$ATLASSIAN_DOMAINS.some((domain)=>hostname.endsWith(domain));
const $89aa0ef6b16bedeb$var$isValidUrl = (urlString)=>{
    if (typeof urlString !== 'string') return false;
    try {
        return Boolean(new URL(urlString));
    } catch (e) {
        return false;
    }
};
const $89aa0ef6b16bedeb$export$280e79c794cf814e = (url)=>$89aa0ef6b16bedeb$var$isValidUrl(url) ? new URL(url)?.hostname : '';
const $89aa0ef6b16bedeb$export$33c8f371dcc1b989 = (ari)=>{
    if (!ari || typeof ari !== 'string') return null;
    try {
        const parsedAri = (0, $a2xFu.ConfluencePageAri).parse(ari);
        return parsedAri && parsedAri.cloudId ? parsedAri.cloudId : null;
    } catch (err) {
        return null;
    }
};
const $89aa0ef6b16bedeb$export$193bb0d0d16ee7a7 = (parentCloudId, url, ari)=>{
    const parentHost = $89aa0ef6b16bedeb$export$280e79c794cf814e(window?.location?.href) || '';
    const contentHost = $89aa0ef6b16bedeb$export$280e79c794cf814e(url);
    if (parentHost === contentHost) return url;
    const cloudId = $89aa0ef6b16bedeb$export$33c8f371dcc1b989(ari);
    if (!cloudId || !parentCloudId || parentCloudId !== cloudId || !$89aa0ef6b16bedeb$export$97f4c254b641e719(parentHost)) return url;
    // Swap the URL hostname to use the parent's hostname
    try {
        const urlObj = new URL(url);
        urlObj.hostname = parentHost;
        return urlObj.toString();
    } catch (error) {
        // If URL parsing fails, return original URL
        return url;
    }
};



var $6mKj3 = parcelRequire("6mKj3");


var $lhTEt = parcelRequire("lhTEt");


var $i6Ps3 = parcelRequire("i6Ps3");


var $9wGTI = parcelRequire("9wGTI");


var $7W8i8 = parcelRequire("7W8i8");


var $ep3mz = parcelRequire("ep3mz");


var $1NBp8 = parcelRequire("1NBp8");


var $gz8ZY = parcelRequire("gz8ZY");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");





var $6JLuV = parcelRequire("6JLuV");

const $7ac1c4b85cd786d3$export$d48d5704d1181ce6 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(3);
    const { open: open } = (0, $6JLuV.useOpenPreviewPanel)();
    let t0;
    let t1;
    if ($[0] !== open) {
        t0 = ()=>{
            const handleMessage = (event)=>{
                const { payload: payload } = event.data;
                if (event.data?.type !== "OPEN_PREVIEW_PANEL") return;
                if (payload?.url) open(payload);
            };
            window.addEventListener("message", handleMessage);
            return ()=>{
                window.removeEventListener("message", handleMessage);
            };
        };
        t1 = [
            open
        ];
        $[0] = open;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $42omo.useEffect)(t0, t1);
    return null;
} : ()=>{
    const { open: open } = (0, $6JLuV.useOpenPreviewPanel)();
    // Listen for messages from iframes to open preview panels
    (0, $42omo.useEffect)(()=>{
        const handleMessage = (event)=>{
            const { payload: payload } = event.data;
            // Only handle messages with the expected type
            if (event.data?.type !== 'OPEN_PREVIEW_PANEL') return;
            if (payload?.url) open(payload);
        };
        window.addEventListener('message', handleMessage);
        return ()=>{
            window.removeEventListener('message', handleMessage);
        };
    }, [
        open
    ]);
    return null;
};






var $27fJD = parcelRequire("27fJD");


var $cEgMD = parcelRequire("cEgMD");


var $e4o8D = parcelRequire("e4o8D");


var $fFmJj = parcelRequire("fFmJj");


var $ij4CE = parcelRequire("ij4CE");


var $k00oi = parcelRequire("k00oi");


var $477dG = parcelRequire("477dG");

const $de526bdbda89b480$var$deferIdle = (cb)=>{
    if ('requestIdleCallback' in window) requestIdleCallback(cb, {
        timeout: 5000
    });
    else requestAnimationFrame(cb);
};
class $de526bdbda89b480$export$385f1396b754ac80 extends (0, $k00oi.default) {
    // Called once per page load
    prefetchData(url) {
        return super.prefetchData(url).then((data)=>{
            // Using deferIdle(requestIdleCallback) to ensure our onResolve callback doesn't interrupt the smart card client.
            // This means there's a chance under heavy browser load that the delay between client (pre)fetch and onResolve invocation will be >1s, but usually it shouldn't be.
            // Given the data schema is unstable, we're setting the type as unknown and expecting individual resolvers to be mindful.
            data && $de526bdbda89b480$var$deferIdle(()=>this.onResolve(data));
            return data;
        });
    }
    // Called on load and on click of each smart card link
    async fetchData(url, force) {
        if (!force) return this.editorCardProvider.getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS({
            // It's ok to cast any resourceUrl to inlineCard here, because only URL is important for the request.
            type: 'inlineCard',
            attrs: {
                url: url
            }
        }).then((data)=>{
            data && $de526bdbda89b480$var$deferIdle(()=>this.onResolve(data));
            return data;
        });
        return super.fetchData(url, force).then((data)=>{
            data && $de526bdbda89b480$var$deferIdle(()=>this.onResolve(data));
            return data;
        });
    }
    constructor(props){
        const { onResolve: onResolve, envKey: envKey } = props;
        super(envKey);
        this.onResolve = void 0;
        this.editorCardProvider = void 0;
        this.onResolve = onResolve;
        // Because Card components uses data from client and it's super hard to pass EditorCardProvider to them,
        // we will create a new EditorCardProvider instance here and use it for SSR support.
        this.editorCardProvider = new (0, $477dG.EditorCardProvider)(this.envKey, this.baseUrlOverride, 'CONFLUENCE');
        const ssrProvidersData = window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] || {};
        const ssrData = ssrProvidersData[this.editorCardProvider.name];
        this.editorCardProvider.setSSRData(ssrData);
    }
}



var $9sGCn = parcelRequire("9sGCn");

const $901e3ce3ee925fd9$var$getContentIdFromResolvedData = (resolvedData)=>{
    const ari = resolvedData.data['atlassian:ari'];
    return ari?.substring?.(ari?.lastIndexOf?.('/') + 1);
};
// data.data['@type'] will have two elements, for example ['schema:DigitalDocument', 'Document'], where 'schema:DigitalDocument' specifically denotes a live doc
// The resolve logic doesn't consistently position these two elements in the @type array, so the schema we need to validate may be in the 0th or 1st element
const $901e3ce3ee925fd9$var$isResolvedDataUnarchivedLiveDoc = (resolvedData)=>{
    const typeArr = resolvedData.data['@type'];
    const isLiveDoc = typeArr?.[0] === 'schema:DigitalDocument' || typeArr?.[1] === 'schema:DigitalDocument';
    const isArchived = resolvedData.data['atlassian:state'] === 'archived';
    return isLiveDoc && !isArchived;
};
const $901e3ce3ee925fd9$var$isResolvedDataValid = (resolvedData)=>{
    if (!resolvedData || typeof resolvedData !== 'object') return false;
    const data = resolvedData.data;
    const meta = resolvedData.meta;
    if (!data || !meta) return false;
    if (!('@context' in data)) return false;
    const type = data['@type'];
    if (typeof type !== 'string' && !Array.isArray(type)) return false;
    return true;
};
let $901e3ce3ee925fd9$var$hasInvalidResolverDataAnalyticsEventTriggered = false;
const $901e3ce3ee925fd9$export$e1f1443d16a1c263 = (createAnalyticsEvent, readFragmentInterop, writeFragmentInterop, resolvedData)=>{
    if ($901e3ce3ee925fd9$var$isResolvedDataValid(resolvedData)) {
        if ($901e3ce3ee925fd9$var$isResolvedDataUnarchivedLiveDoc(resolvedData)) {
            const contentId = $901e3ce3ee925fd9$var$getContentIdFromResolvedData(resolvedData);
            if (contentId) {
                let existingCachedData;
                try {
                    existingCachedData = readFragmentInterop({
                        id: `Content:${contentId}`
                    });
                } catch  {
                // readFragment throws an error if no data is found
                }
                // Reads are cheaper than writes, so only write if we don't already have the correct data in cache.
                if (!existingCachedData || existingCachedData?.subType !== 'live' || existingCachedData?.status !== 'current') {
                    writeFragmentInterop({
                        fragmentId: `Content:${contentId}`,
                        // status is current if we are an unarchived live doc
                        data: {
                            __typename: 'Content',
                            id: contentId,
                            subType: 'live',
                            status: 'current'
                        }
                    });
                    // Since graphql cache has been updated, make sure the memoization cache for getCachedPageData is cleared
                    // So if getCachedPageData is called again with the same content id, it will read the updated graphql cache instead of returning the memoized data
                    (0, $9sGCn.clearMemoizedCachedPageData)();
                }
            }
        }
    } else // If resolved data schema is invalid, we likely need to update it ASAP as Linking Platform's content resolver service API may have changed
    if (!$901e3ce3ee925fd9$var$hasInvalidResolverDataAnalyticsEventTriggered) {
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'invalidResolverData',
                actionSubject: 'liveDocSmartCardResolver',
                source: 'confluenceSmartCardProvider'
            }
        }).fire();
        // Only send this event once per load to reduce load on analytics pipeline
        $901e3ce3ee925fd9$var$hasInvalidResolverDataAnalyticsEventTriggered = true;
    }
};


// Only log first error to console, to prevent spamming console with resolver errors
let $3c75c8f77ed4b940$var$hasLoggedResolverError = false;
const $3c75c8f77ed4b940$var$defaultConfluenceResolveHandler = (createAnalyticsEvent, readFragmentInterop, writeFragmentInterop, data)=>{
    try {
        // NOTE FOR DEVS OF RESOLVERS: The `data` object comes from linking platform's content resolver service which is an UNSTABLE API SCHEMA.
        // Ensure your resolver logic handles invalid schemas gracefully and is able to notify your team if the schema changes and your code needs to be updated.
        (0, $901e3ce3ee925fd9$export$e1f1443d16a1c263)(createAnalyticsEvent, readFragmentInterop, writeFragmentInterop, data);
    } catch (resolverError) {
        // prevent errors from causing smart card provider issues
        if (!$3c75c8f77ed4b940$var$hasLoggedResolverError) {
            const logger = (0, $7W8i8.getLogger)('ConfluenceSmartCardProvider');
            logger.error`resolver error: ${resolverError}`;
            $3c75c8f77ed4b940$var$hasLoggedResolverError = true;
        }
    }
};
const $3c75c8f77ed4b940$var$CurrentSmartCardProvider = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $5fd779f9cf97f4fb$export$2e2bcd8739ae039)
    });
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $896ad30c32f2cdd3$export$2e2bcd8739ae039)
    });
    const smartCardClient = (0, $42omo.useMemo)(()=>props?.client || new (0, $de526bdbda89b480$export$385f1396b754ac80)({
            onResolve: (data)=>$3c75c8f77ed4b940$var$defaultConfluenceResolveHandler(createAnalyticsEvent, readFragmentInterop, writeFragmentInterop, data)
        }), [
        props?.client,
        createAnalyticsEvent,
        readFragmentInterop,
        writeFragmentInterop
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7bZ3i.SmartCardProvider), {
        product: "CONFLUENCE",
        client: smartCardClient,
        ...props
    });
};
const $3c75c8f77ed4b940$var$ConsolidatedSmartCardProvider = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $2114907496ee9554$export$2e2bcd8739ae039)
    });
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $ecbb6e526a968754$export$2e2bcd8739ae039)
    });
    const smartCardClient = (0, $42omo.useMemo)(()=>props?.client || new (0, $de526bdbda89b480$export$385f1396b754ac80)({
            onResolve: (data)=>$3c75c8f77ed4b940$var$defaultConfluenceResolveHandler(createAnalyticsEvent, readFragmentInterop, writeFragmentInterop, data)
        }), [
        props?.client,
        createAnalyticsEvent,
        readFragmentInterop,
        writeFragmentInterop
    ]);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const isPageSSR = (0, $i6Ps3.isPageSSRd)();
    const initialState = window['__SSR_SMARTLINKS__'];
    const internalStoreOptions = (0, $lhTEt.useStoreOptions)(initialState, isPageSSR);
    // Merge smartlink SSR data with any passed-in storeOptions (e.g. from shortcuts preloader)
    const presetInitialState = {
        ...internalStoreOptions,
        ...props.storeOptions ? {
            storeOptions: {
                ...internalStoreOptions.storeOptions || {},
                ...props.storeOptions
            }
        } : {}
    };
    const shouldControlDataExport = (0, $dPJCf.useIsOnRoute)((0, $1NBp8.PDF_EXPORT_PAGE));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7bZ3i.SmartCardProvider), {
        product: "CONFLUENCE",
        client: smartCardClient,
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        shouldControlDataExport: shouldControlDataExport,
        isPreviewPanelAvailable: props.isPreviewPanelAvailable,
        openPreviewPanel: props.openPreviewPanel,
        ...presetInitialState,
        ...props
    });
};
const $3c75c8f77ed4b940$var$ConsolidatedPreviewPanelSmartCardProvider = (props)=>{
    const { open: open } = (0, $6JLuV.useOpenPreviewPanel)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    // Create a wrapper function that updates the preview panel URL
    // This is used for custom domains to update to the correct content URL and avoid CSP issues
    const openPreviewPanelWithModifiedURL = (0, $42omo.useMemo)(()=>{
        if (!cloudId) return open;
        return ({ url: url, ari: ari, ...rest })=>open({
                url: (0, $89aa0ef6b16bedeb$export$193bb0d0d16ee7a7)(cloudId, url, ari),
                ari: ari,
                ...rest
            });
    }, [
        open,
        cloudId
    ]);
    const { children: children, doNotUsePreviewPanels: doNotUsePreviewPanels, ...restProps } = props;
    return (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) || doNotUsePreviewPanels ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3c75c8f77ed4b940$var$ConsolidatedSmartCardProvider, restProps, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3c75c8f77ed4b940$var$ConsolidatedSmartCardProvider, {
        openPreviewPanel: openPreviewPanelWithModifiedURL,
        isPreviewPanelAvailable: renderServerPlaceholder && (0, $9wGTI.fg)('confluence_fix_smartlink_hydration_error') ? (_ari)=>false : (0, $27fJD.isPreviewPanelAvailable),
        ...restProps
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ac1c4b85cd786d3$export$d48d5704d1181ce6), null));
};
const $3c75c8f77ed4b940$export$a56ebeb3c828cd38 = (props)=>{
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    if ((0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true)) return isNav4Enabled && (0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3c75c8f77ed4b940$var$ConsolidatedPreviewPanelSmartCardProvider, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3c75c8f77ed4b940$var$ConsolidatedSmartCardProvider, props);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3c75c8f77ed4b940$var$CurrentSmartCardProvider, props);
};
module.exports["ConfluenceSmartCardProvider"] = $3c75c8f77ed4b940$export$a56ebeb3c828cd38;

});

parcelRegister("lhTEt", function(module, exports) {

var $frIzR = parcelRequire("frIzR");

const $b667503c95136f0a$export$53d21446ea17fdf1 = (initialState, isPageSSRd)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if (initialState && isPageSSRd) {
        let t1;
        if ($[0] !== initialState) {
            t1 = {
                storeOptions: {
                    initialState: initialState
                }
            };
            $[0] = initialState;
            $[1] = t1;
        } else t1 = $[1];
        t0 = t1;
    } else {
        let t1;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = {};
            $[2] = t1;
        } else t1 = $[2];
        t0 = t1;
    }
    return t0;
};
module.exports["useStoreOptions"] = $b667503c95136f0a$export$53d21446ea17fdf1;

});

parcelRegister("i6Ps3", function(module, exports) {
// Returns true on SSR and SPA if page was SSR'd
const $70ad96d323d38e4d$export$a8c2f05884e8c7a1 = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return Boolean(window.__SSR_RENDERED__);
};
module.exports["isPageSSRd"] = $70ad96d323d38e4d$export$a8c2f05884e8c7a1;

});

parcelRegister("6JLuV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $eIleF = parcelRequire("eIleF");


var $k4HRJ = parcelRequire("k4HRJ");

var $a2xFu = parcelRequire("a2xFu");

var $eMqrF = parcelRequire("eMqrF");

var $b8JCF = parcelRequire("b8JCF");

var $ixcaU = parcelRequire("ixcaU");

var $5JRMI = parcelRequire("5JRMI");


var $dj7jL = parcelRequire("dj7jL");

var $1DfVr = parcelRequire("1DfVr");


var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $irOoi = parcelRequire("irOoi");


var $fwXBL = parcelRequire("fwXBL");


var $gJsgh = parcelRequire("gJsgh");


var $8jHAi = parcelRequire("8jHAi");


var $bVHZY = parcelRequire("bVHZY");


var $1dKyn = parcelRequire("1dKyn");


var $ZDq1z = parcelRequire("ZDq1z");


var $2qVkt = parcelRequire("2qVkt");


var $7ZcJJ = parcelRequire("7ZcJJ");


var $dh538 = parcelRequire("dh538");





var $aH9Q1 = parcelRequire("aH9Q1");


var $cab2i = parcelRequire("cab2i");


const $d2a6d778f42989cd$export$a50c261b4b52f403 = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("io4wE"))), {
        moduleId: "d73b44f1",
        priority: "interaction",
        moduleId: 'confluence-preview-panel-entrypoint'
    }),
    getPreloadProps: ()=>({})
});



var $4TXTZ = parcelRequire("4TXTZ");








var $2JrHF = parcelRequire("2JrHF");

const $ac6dd892357cddb5$var$fetchPolicy = 'network-only';

const $ac6dd892357cddb5$var$atlasGoalEntryPoint = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("8CsnF")).then((mod)=>mod.GoalPanel), {
        moduleId: "ba76ccc1",
        moduleName: "GoalPanel",
        priority: "interaction",
        moduleId: 'atlas-goal-entrypoint'
    }),
    getPreloadProps: ({ ari: ari })=>{
        (0, $4TXTZ.default)('townsquare-goal-panel-opened');
        return {
            queries: {
                queryReference: {
                    parameters: $2JrHF.default,
                    variables: {
                        ari: ari
                    },
                    options: {
                        fetchPolicy: $ac6dd892357cddb5$var$fetchPolicy
                    }
                }
            }
        };
    }
});
var $ac6dd892357cddb5$export$2e2bcd8739ae039 = $ac6dd892357cddb5$var$atlasGoalEntryPoint;









const $1a4e8a680740cd08$var$objectPreviewPanelEntryPoint = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("7MBP8")).then((mod)=>mod.ObjectPreviewPanel), {
        moduleId: "bb3d75a4",
        priority: "interaction",
        moduleId: 'object-preview-panel-entrypoint'
    }),
    getPreloadProps: ({})=>({})
});
var $1a4e8a680740cd08$export$2e2bcd8739ae039 = $1a4e8a680740cd08$var$objectPreviewPanelEntryPoint;



var $4BDAe = parcelRequire("4BDAe");


var $c6GJD = parcelRequire("c6GJD");











var $fff9r = parcelRequire("fff9r");

const $b6e606f8c0a01996$var$fetchPolicy = 'network-only';

const $b6e606f8c0a01996$var$atlasProjectEntryPoint = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("4Io4R")).then((mod)=>mod.ProjectPanel), {
        moduleId: "db5db9ea",
        moduleName: "ProjectPanel",
        priority: "interaction",
        moduleId: 'atlas-project-entrypoint'
    }),
    getPreloadProps: ({ ari: ari })=>{
        (0, $4TXTZ.default)('townsquare-project-panel-opened');
        // check for M0 or greater
        const isProjectNativeIntegrationEnabled = (0, $c6GJD.default).getExperimentValue('atlassian_projects_-_native_integration', 'releaseVersion', -1) >= 0;
        return {
            queries: {
                queryReference: {
                    parameters: $fff9r.default,
                    variables: {
                        ari: ari,
                        isProjectNativeIntegrationEnabled: isProjectNativeIntegrationEnabled
                    },
                    options: {
                        fetchPolicy: $b6e606f8c0a01996$var$fetchPolicy
                    }
                }
            }
        };
    }
});
var $b6e606f8c0a01996$export$2e2bcd8739ae039 = $b6e606f8c0a01996$var$atlasProjectEntryPoint;


/*
 * Get the default tab from the url
 * Post T25 EU task: Support other URL routing (jira/jira-align/highlights, ect)
 * TODO: https://product-fabric.atlassian.net/browse/TC-14119
 */ function $35e8e01797ae2575$export$68d1d951742105ed(url) {
    // About | Updates | {other tabs}
    if (url.includes('updates')) return 'updates';
    return 'about';
}



var $gWF6I = parcelRequire("gWF6I");








var $i84MD = parcelRequire("i84MD");

const $b818cac8be61238d$var$fetchPolicy = 'network-only';

const $b818cac8be61238d$var$teamPreviewPanelEntryPoint = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("heXUE")).then((mod)=>mod.TeamPreviewPanel), {
        moduleId: "bc41c2d8",
        priority: "interaction",
        moduleId: 'team-preview-panel-entrypoint'
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                queryReference: {
                    parameters: $i84MD.default,
                    variables: {
                        cloudId: cloudId
                    },
                    options: {
                        fetchPolicy: $b818cac8be61238d$var$fetchPolicy
                    }
                }
            }
        })
});
var $b818cac8be61238d$export$2e2bcd8739ae039 = $b818cac8be61238d$var$teamPreviewPanelEntryPoint;


const $2bcdee8d1b1c44c4$export$cec6f7cb9c99f251 = [
    'jira-issue',
    'confluence-page',
    'identity-team',
    'townsquare-goal',
    'townsquare-project',
    'cmdb-object'
];



var $cgtv4 = parcelRequire("cgtv4");

var $721536e6a2e4576b$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    workItem: {
        id: "navigation.preview-panel-global-objects.workItem",
        defaultMessage: "Jira work item"
    },
    project: {
        id: "navigation.preview-panel-global-objects.project",
        defaultMessage: "Project"
    },
    goal: {
        id: "navigation.preview-panel-global-objects.goal",
        defaultMessage: "Goal"
    },
    team: {
        id: "navigation.preview-panel-global-objects.team",
        defaultMessage: "Team"
    },
    page: {
        id: "navigation.preview-panel-global-objects.page",
        defaultMessage: "Confluence Page"
    },
    whiteboard: {
        id: "navigation.preview-panel-global-objects.whiteboard",
        defaultMessage: "Confluence Whiteboard"
    },
    object: {
        id: "navigation.preview-panel-global-objects.object",
        defaultMessage: "Assets Object"
    }
});









var $48FEk = parcelRequire("48FEk");

/* ErrorFallbackPreviewPanel.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $abC4X = parcelRequire("abC4X");


var $2Nwuj = parcelRequire("2Nwuj");


var $ibFXh = parcelRequire("ibFXh");

var $aSy6D = parcelRequire("aSy6D");

var $3ZVni = parcelRequire("3ZVni");

var $3R2u2 = parcelRequire("3R2u2");




var $8ca7114f2e83ff40$exports = {};
$8ca7114f2e83ff40$exports = new URL("ErrorGeneric.5fda5790.svg", import.meta.url).toString();





const $9e3978ea1fc35db1$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    errorHeader: {
        id: "navigation.preview-panel-global-objects.panels.error-header",
        defaultMessage: "Can\u2019t load details"
    },
    errorDescription: {
        id: "navigation.preview-panel-global-objects.panels.error-description",
        defaultMessage: "We\u2019ve got all hands on deck working to get you back up and running. For more information, <link>check our status page</link>."
    }
});


const $a06bcd4811576243$var$styles = {
    body: "_bozgxncg _y4tixncg _1q511ejb _85i51ejb"
};
const $a06bcd4811576243$export$9f31ac9d4b42e91c = /*#__PURE__*/ (0, $42omo.memo)(({ url: url, name: name, icon: icon })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $ibFXh.PreviewPanel), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3ZVni.PreviewPanelHeader), {
                onClose: close,
                url: url,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3R2u2.PreviewPanelTitle), {
                    title: name,
                    icon: icon
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $aSy6D.PreviewPanelBody), {
                styles: $a06bcd4811576243$var$styles.body,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $abC4X.default), {
                    header: formatMessage((0, $9e3978ea1fc35db1$export$defe85febe8b728c).errorHeader),
                    description: formatMessage((0, $9e3978ea1fc35db1$export$defe85febe8b728c).errorDescription, {
                        link: (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                href: "https://status.atlassian.com/",
                                children: chunks
                            })
                    }),
                    headingLevel: 2,
                    imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($8ca7114f2e83ff40$exports)))
                })
            })
        ]
    });
});


/* FallbackPreviewPanel.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gMc0m = parcelRequire("gMc0m");













const $6d87b0f37db700b5$var$styles = {
    body: "_zulppxbi _1e0c1txw _2lx21bp4 _16jlkb7n _18m91wug _bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi",
    skeleton: "_2rko12b0 _1e0c1txw _bfhkizff _4t3igktf",
    skeletonRow1: "_1bsb1osq",
    skeletonRow2: "_1bsb1nrf",
    skeletonRow3: "_1bsb1w8u",
    skeletonRow4: "_1bsbhwvj"
};
const $6d87b0f37db700b5$export$97ea7ee86eec0667 = /*#__PURE__*/ (0, $42omo.memo)(({ url: url, name: name, icon: icon })=>{
    const { close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $ibFXh.PreviewPanel), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3ZVni.PreviewPanelHeader), {
                onClose: close,
                url: url,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3R2u2.PreviewPanelTitle), {
                    title: name,
                    icon: icon
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $aSy6D.PreviewPanelBody), {
                styles: $6d87b0f37db700b5$var$styles.body,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            $6d87b0f37db700b5$var$styles.skeleton,
                            $6d87b0f37db700b5$var$styles.skeletonRow1
                        ])
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            $6d87b0f37db700b5$var$styles.skeleton,
                            $6d87b0f37db700b5$var$styles.skeletonRow2
                        ])
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            $6d87b0f37db700b5$var$styles.skeleton,
                            $6d87b0f37db700b5$var$styles.skeletonRow3
                        ])
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            $6d87b0f37db700b5$var$styles.skeleton,
                            $6d87b0f37db700b5$var$styles.skeletonRow4
                        ])
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            $6d87b0f37db700b5$var$styles.skeleton,
                            $6d87b0f37db700b5$var$styles.skeletonRow1
                        ])
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            $6d87b0f37db700b5$var$styles.skeleton,
                            $6d87b0f37db700b5$var$styles.skeletonRow2
                        ])
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            $6d87b0f37db700b5$var$styles.skeleton,
                            $6d87b0f37db700b5$var$styles.skeletonRow3
                        ])
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            $6d87b0f37db700b5$var$styles.skeleton,
                            $6d87b0f37db700b5$var$styles.skeletonRow4
                        ])
                    })
                ]
            })
        ]
    });
});


const $1b27a03431ccc931$var$emptyEntryPointProps = {};
const $1b27a03431ccc931$export$2ace74dd551e05c1 = ({ entryPoint: entryPoint, preloadedEntryPointReference: preloadedEntryPointReference, runtimeProps: runtimeProps = $1b27a03431ccc931$var$emptyEntryPointProps, globalObject: globalObject })=>{
    const id = (0, $42omo.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $48FEk.InternalEntryPointContainer), {
        id: id,
        entryPointReference: preloadedEntryPointReference,
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $6d87b0f37db700b5$export$97ea7ee86eec0667), {
            ...globalObject
        }),
        errorFallback: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $a06bcd4811576243$export$9f31ac9d4b42e91c), {
                ...globalObject
            }),
        runtimeProps: runtimeProps
    });
};


/* IFramePreviewPanel.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $a9sR2 = parcelRequire("a9sR2");

var $5DUgU = parcelRequire("5DUgU");





var $cOrQJ = parcelRequire("cOrQJ");




















const $57b48019462940b6$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
const $57b48019462940b6$export$5b60458e6ab1ba54 = (value)=>{
    if (!(0, $2bcdee8d1b1c44c4$export$cec6f7cb9c99f251).includes(value)) throw new Error(`Unsupported global object type: ${value}`);
    return value;
};
const $57b48019462940b6$export$4e691bca3211cc2f = (url, supportedObjects, rootSourceScreen)=>{
    try {
        const urlObj = new URL(url);
        // Ensure there's no trailing slash before appending '/embed'
        urlObj.pathname = urlObj.pathname.replace(/\/$/, '') + '/embed';
        // Add previewPanels to existing search params
        urlObj.searchParams.set('previewPanels', supportedObjects.join(','));
        if (rootSourceScreen && (0, $dh538.fg)('add_capacity_tab_to_the_board_horizontal_nav')) urlObj.searchParams.set('previewRootSourceScreen', rootSourceScreen);
        // Return the full URL as a string
        return urlObj.toString();
    } catch  {
        // Fallback for invalid URLs
        if ((0, $dh538.fg)('add_capacity_tab_to_the_board_horizontal_nav')) {
            const encodedRootSource = rootSourceScreen ? `&previewRootSource=${encodeURIComponent(rootSourceScreen)}` : '';
            return `${url}/embed?previewPanels=${encodeURIComponent(supportedObjects.join(','))}${encodedRootSource}`;
        } else return `${url}/embed?previewPanels=${encodeURIComponent(supportedObjects.join(','))}`;
    }
};
const $57b48019462940b6$export$4acedbb0ac692186 = (hostname)=>{
    if (hostname.includes('localhost') || hostname.includes('jira-dev')) return (0, $5DUgU.envType).DEV;
    return (0, $5DUgU.envType).PROD;
};


const $e0021b485e98a5e2$var$styles = {
    iframe: "_19itglyw _1bsb1osq _4t3i1osq",
    body: "_1e0c1txw _16jlkb7n _18m91wug"
};
const $e0021b485e98a5e2$export$6c67178058384ea6 = (ari)=>{
    if (!ari || typeof ari !== 'string' || !ari.startsWith('ari:cloud:jira:')) return undefined;
    const parts = ari.split(':');
    if (parts.length !== 5) return undefined;
    const cloudId = parts[3];
    if (!cloudId) return undefined;
    return cloudId;
};
const $e0021b485e98a5e2$export$83f0623b6f97b032 = /*#__PURE__*/ (0, $42omo.memo)(({ url: url, iframeUrl: iframeUrl, name: name, icon: icon, panelType: panelType, product: product, parentProduct: parentProduct, ari: ari, analyticsAttributes: analyticsAttributes })=>{
    const { close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    const [analyticsClient, setAnalyticsClient] = (0, $42omo.useState)();
    const cloudId = ari ?? $e0021b485e98a5e2$export$6c67178058384ea6(ari);
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    (0, $42omo.useEffect)(()=>{
        setAnalyticsClient(()=>{
            let analyticsClient = new (0, $a9sR2.default)({
                product: product,
                env: (0, $57b48019462940b6$export$4acedbb0ac692186)(window.location.hostname),
                origin: (0, $5DUgU.originType).WEB
            });
            if (cloudId) analyticsClient?.setTenantInfo((0, $5DUgU.tenantType).CLOUD_ID, cloudId);
            return analyticsClient;
        });
    }, [
        product,
        cloudId
    ]); // Create iframe URL with theme parameter
    const iframeSrc = (0, $42omo.useMemo)(()=>{
        if (!iframeUrl || !colorMode) return iframeUrl;
        const url = new URL(iframeUrl, window.location.origin);
        url.searchParams.set('themeMode', colorMode);
        return url.toString();
    }, [
        iframeUrl,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $ibFXh.PreviewPanel), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3ZVni.PreviewPanelHeader), {
                onClose: close,
                url: url,
                parentProduct: parentProduct,
                panelType: panelType,
                analyticsClient: analyticsClient,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3R2u2.PreviewPanelTitle), {
                    title: name,
                    icon: icon
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $aSy6D.PreviewPanelBody), {
                styles: $e0021b485e98a5e2$var$styles.body,
                parentProduct: parentProduct,
                panelType: panelType,
                analyticsClient: analyticsClient,
                ...(0, $dh538.fg)('add_capacity_tab_to_the_board_horizontal_nav') ? {
                    analyticsAttributes: analyticsAttributes
                } : {},
                children: /*#__PURE__*/ (0, $l998X.jsx)("iframe", {
                    src: iframeSrc,
                    title: name,
                    className: (0, $gMc0m.default)([
                        $e0021b485e98a5e2$var$styles.iframe
                    ])
                })
            })
        ]
    });
});



const $a7dbab6e358b50cb$var$getGlobalObjectType = (ari)=>{
    const parsedAri = (0, $k4HRJ.AnyAri).parse(ari);
    return `${parsedAri.resourceOwner}-${parsedAri.resourceType}`;
};
const $a7dbab6e358b50cb$export$70bcacea0b970dee = (product, cloudId, options)=>{
    const { enabled: enabled = true, supportedObjects: supportedObjects = (0, $2bcdee8d1b1c44c4$export$cec6f7cb9c99f251), analyticsAttributes: analyticsAttributes, rootSourceScreen: rootSourceScreen } = options ?? {};
    const environmentProvider = (0, $gWF6I.useRelayEnvironmentProvider)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { open: open } = (0, $4BDAe.usePreviewPanelsActions)();
    const isPreviewPanelAvailable = (0, $42omo.useCallback)(({ ari: ari })=>enabled && supportedObjects.includes($a7dbab6e358b50cb$var$getGlobalObjectType(ari)), [
        enabled,
        supportedObjects
    ]);
    const openPreviewPanel = (0, $42omo.useCallback)(({ url: url, ari: ari, name: name, parentProduct: parentProduct, panelData: panelData })=>{
        const globalObjectType = $a7dbab6e358b50cb$var$getGlobalObjectType(ari);
        if (!isPreviewPanelAvailable({
            ari: ari
        })) throw new Error(`Preview panel for ${globalObjectType} with ARI ${ari} is not supported.`);
        // Check if we're in an iframe (not the top-most frame)
        if ((0, $57b48019462940b6$export$9f140ed41af5108c)()) {
            // Post message to parent frame to open the panel
            window.parent.postMessage({
                type: 'OPEN_PREVIEW_PANEL',
                payload: {
                    url: url,
                    ari: ari,
                    name: name,
                    panelData: panelData
                }
            }, '*');
            return;
        }
        let panelContent;
        let panelProduct;
        switch(globalObjectType){
            case 'jira-issue':
                const JiraIcon = product === 'jira' ? (0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))) : (0, (/*@__PURE__*/$parcel$interopDefault($7ZcJJ)));
                const title = formatMessage((0, $721536e6a2e4576b$export$2e2bcd8739ae039).workItem);
                panelContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $e0021b485e98a5e2$export$83f0623b6f97b032), {
                    name: title,
                    url: url,
                    iframeUrl: (0, $dh538.fg)('add_capacity_tab_to_the_board_horizontal_nav') ? (0, $57b48019462940b6$export$4e691bca3211cc2f)(url, supportedObjects, rootSourceScreen) : (0, $57b48019462940b6$export$4e691bca3211cc2f)(url, supportedObjects),
                    icon: /*#__PURE__*/ (0, $l998X.jsx)(JiraIcon, {
                        label: ""
                    }),
                    panelType: "jira-work-item",
                    product: "jira",
                    parentProduct: parentProduct,
                    ari: ari,
                    ...(0, $dh538.fg)('add_capacity_tab_to_the_board_horizontal_nav') ? {
                        analyticsAttributes: analyticsAttributes
                    } : {}
                });
                panelProduct = 'jira';
                break;
            case 'identity-team':
                const teamEntryPointReference = (0, $irOoi.loadEntryPoint)(environmentProvider, (0, $b818cac8be61238d$export$2e2bcd8739ae039), {
                    cloudId: cloudId
                });
                panelContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $1b27a03431ccc931$export$2ace74dd551e05c1), {
                    entryPoint: (0, $b818cac8be61238d$export$2e2bcd8739ae039),
                    preloadedEntryPointReference: teamEntryPointReference,
                    runtimeProps: {
                        url: url,
                        parentProduct: product,
                        ari: ari,
                        cloudId: cloudId,
                        openPreviewPanel: openPreviewPanel
                    },
                    globalObject: {
                        name: formatMessage((0, $721536e6a2e4576b$export$2e2bcd8739ae039).team),
                        url: url,
                        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1dKyn))), {
                            label: ""
                        })
                    }
                });
                panelProduct = 'people';
                break;
            case 'townsquare-goal':
                const entryPointReference = (0, $irOoi.loadEntryPoint)(environmentProvider, (0, $ac6dd892357cddb5$export$2e2bcd8739ae039), {
                    ari: ari
                });
                panelContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $1b27a03431ccc931$export$2ace74dd551e05c1), {
                    entryPoint: (0, $ac6dd892357cddb5$export$2e2bcd8739ae039),
                    preloadedEntryPointReference: entryPointReference,
                    runtimeProps: {
                        url: url,
                        parentProduct: product,
                        cloudId: cloudId,
                        defaultTab: (0, $35e8e01797ae2575$export$68d1d951742105ed)(url)
                    },
                    globalObject: {
                        name: formatMessage((0, $721536e6a2e4576b$export$2e2bcd8739ae039).goal),
                        url: url,
                        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gJsgh))), {
                            label: ""
                        })
                    }
                });
                panelProduct = 'townsquare';
                break;
            case 'townsquare-project':
                {
                    const entryPointReference = (0, $irOoi.loadEntryPoint)(environmentProvider, (0, $b6e606f8c0a01996$export$2e2bcd8739ae039), {
                        ari: ari
                    });
                    panelContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $1b27a03431ccc931$export$2ace74dd551e05c1), {
                        entryPoint: (0, $b6e606f8c0a01996$export$2e2bcd8739ae039),
                        preloadedEntryPointReference: entryPointReference,
                        runtimeProps: {
                            url: url,
                            parentProduct: product,
                            cloudId: cloudId,
                            defaultTab: (0, $35e8e01797ae2575$export$68d1d951742105ed)(url)
                        },
                        globalObject: {
                            name: formatMessage((0, $721536e6a2e4576b$export$2e2bcd8739ae039).project),
                            url: url,
                            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bVHZY))), {
                                label: ""
                            })
                        }
                    });
                    panelProduct = 'townsquare';
                    break;
                }
            case 'confluence-page':
                {
                    const urlObj = new URL(url);
                    urlObj.searchParams.set('previewPanels', encodeURIComponent((0, $2bcdee8d1b1c44c4$export$cec6f7cb9c99f251).join(',')));
                    const formattedUrl = urlObj.toString();
                    const entryPointReference = (0, $irOoi.loadEntryPoint)(environmentProvider, (0, $d2a6d778f42989cd$export$a50c261b4b52f403), {});
                    panelContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $1b27a03431ccc931$export$2ace74dd551e05c1), {
                        entryPoint: (0, $d2a6d778f42989cd$export$a50c261b4b52f403),
                        preloadedEntryPointReference: entryPointReference,
                        runtimeProps: {
                            url: formattedUrl,
                            parentProduct: product,
                            panelData: panelData,
                            cloudId: cloudId
                        },
                        globalObject: {
                            name: formatMessage((0, $721536e6a2e4576b$export$2e2bcd8739ae039).page),
                            url: formattedUrl,
                            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
                                label: ""
                            })
                        }
                    });
                    panelProduct = 'confluencePreviewPanel';
                    break;
                }
            case 'confluence-whiteboard':
                {
                    const entryPointReference = (0, $irOoi.loadEntryPoint)(environmentProvider, (0, $d2a6d778f42989cd$export$a50c261b4b52f403), {});
                    panelContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $1b27a03431ccc931$export$2ace74dd551e05c1), {
                        entryPoint: (0, $d2a6d778f42989cd$export$a50c261b4b52f403),
                        preloadedEntryPointReference: entryPointReference,
                        runtimeProps: {
                            url: url,
                            parentProduct: product
                        },
                        globalObject: {
                            name: formatMessage((0, $721536e6a2e4576b$export$2e2bcd8739ae039).whiteboard),
                            url: url,
                            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))), {
                                label: ""
                            })
                        }
                    });
                    panelProduct = 'confluencePreviewPanel';
                    break;
                }
            case 'cmdb-object':
                const assetsEntryPointReference = (0, $irOoi.loadEntryPoint)(environmentProvider, (0, $1a4e8a680740cd08$export$2e2bcd8739ae039), {
                    cloudId: cloudId
                });
                panelContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $1b27a03431ccc931$export$2ace74dd551e05c1), {
                    entryPoint: (0, $1a4e8a680740cd08$export$2e2bcd8739ae039),
                    preloadedEntryPointReference: assetsEntryPointReference,
                    runtimeProps: {
                        url: url,
                        parentProduct: product,
                        ari: ari,
                        cloudId: cloudId,
                        openPreviewPanel: openPreviewPanel
                    },
                    // These are fallback properties
                    globalObject: {
                        name: formatMessage((0, $721536e6a2e4576b$export$2e2bcd8739ae039).object),
                        url: url,
                        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fwXBL))), {
                            label: ""
                        })
                    }
                });
                panelProduct = 'assetsPreviewPanel';
                break;
            default:
                throw new Error(`Unsupported global object type: ${globalObjectType}`);
        }
        open({
            panel: {
                id: ari,
                type: globalObjectType,
                content: ()=>panelContent,
                product: panelProduct
            }
        });
    }, [
        isPreviewPanelAvailable,
        open,
        formatMessage,
        supportedObjects,
        environmentProvider,
        product,
        cloudId,
        analyticsAttributes,
        rootSourceScreen
    ]);
    return {
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        openPreviewPanel: openPreviewPanel
    };
};
const $a7dbab6e358b50cb$export$3cfc2fe60a8f0a1c = (openPreviewPanel)=>{
    // Listen for messages from iframes to open panels
    (0, $42omo.useEffect)(()=>{
        const handleMessage = (event)=>{
            // Only handle messages with the expected type
            if (event.data?.type !== 'OPEN_PREVIEW_PANEL') return;
            const { payload: payload } = event.data;
            if (payload?.url && payload?.ari && payload?.name) openPreviewPanel({
                url: payload.url,
                ari: payload.ari,
                name: payload.name,
                panelData: payload.panelData
            });
        };
        window.addEventListener('message', handleMessage);
        return ()=>{
            window.removeEventListener('message', handleMessage);
        };
    }, [
        openPreviewPanel
    ]);
};



var $bQm3c = parcelRequire("bQm3c");


var $27fJD = parcelRequire("27fJD");


var $eToX6 = parcelRequire("eToX6");

/**
 * Resolves Confluence short links to canonical URLs for preview panels.
 * For Confluence short links (e.g., /wiki/x/ABC123), attempts to construct
 * the canonical URL from preview.href parameters.
 */ const $88a4e0a84f25d5c3$var$resolveConfluencePreviewPanelUrl = (originalUrl, response)=>{
    const responseData = response?.data;
    const previewHref = responseData?.preview?.href;
    if (!previewHref) return originalUrl;
    try {
        const previewUrl = new URL(previewHref);
        const contentId = previewUrl.searchParams.get('contentId');
        const spaceKey = previewUrl.searchParams.get('spaceKey');
        const hostname = previewUrl.searchParams.get('hostname');
        if (contentId && spaceKey && hostname) {
            const decodedSpaceKey = decodeURIComponent(spaceKey);
            return `https://${hostname}/wiki/spaces/${decodedSpaceKey}/pages/${contentId}`;
        }
    } catch (error) {
        // If URL parsing fails, fall back to original URL
        return originalUrl;
    }
    return originalUrl;
};
// Helper function to check if previewPanels query parameter is present
const $88a4e0a84f25d5c3$var$hasPreviewPanelsParam = ()=>{
    try {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.has('previewPanels');
    } catch  {
        return false;
    }
};
const $88a4e0a84f25d5c3$var$noop = ()=>{
// this is intentional
};
const $88a4e0a84f25d5c3$export$b92594fec494137a = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(5);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            supportedObjects: (0, $27fJD.ALL_SUPPORTED_OBJECTS)
        };
        $[0] = t0;
    } else t0 = $[0];
    const { openPreviewPanel: openAtlasPreviewPanel } = (0, $a7dbab6e358b50cb$export$70bcacea0b970dee)((0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE, cloudId, t0);
    const { openConfluencePagePreviewPanel: openConfluencePagePreviewPanel } = (0, $1DfVr.useConfluencePagePreviewPanel)((0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE, cloudId);
    const cardContext = (0, $eIleF.useSmartCardContext)();
    let t1;
    if ($[1] !== cardContext || $[2] !== openAtlasPreviewPanel || $[3] !== openConfluencePagePreviewPanel) {
        const open = (t2)=>{
            const { url: url, ari: ari, panelData: panelData } = t2;
            let resolvedUrl = url;
            if (url.includes("/wiki/x/") && cardContext?.value?.store) {
                const cardState = cardContext.value.store.getState()[url];
                if (cardState?.details) resolvedUrl = $88a4e0a84f25d5c3$var$resolveConfluencePreviewPanelUrl(url, cardState.details);
            }
            const name = (0, $k4HRJ.AnyAri).parse(ari).resourceType;
            const formattedName = name.charAt(0).toUpperCase() + name.slice(1);
            if ((0, $eToX6.isInIframe)() && $88a4e0a84f25d5c3$var$hasPreviewPanelsParam()) {
                window.parent.postMessage({
                    type: "OPEN_PREVIEW_PANEL",
                    payload: {
                        url: resolvedUrl,
                        ari: ari,
                        name: formattedName,
                        panelData: panelData
                    }
                }, "*");
                return;
            }
            if ((0, $a2xFu.ConfluencePageAri).check(ari)) {
                const urlObj = new URL(resolvedUrl);
                urlObj.searchParams.set("previewPanels", encodeURIComponent((0, $27fJD.ALL_SUPPORTED_OBJECTS).join(",")));
                openConfluencePagePreviewPanel(urlObj.toString(), $88a4e0a84f25d5c3$var$noop, panelData);
                return;
            }
            if ((0, $ixcaU.TownsquareGoalAri).check(ari)) {
                openAtlasPreviewPanel({
                    url: url,
                    ari: ari,
                    name: "Goal",
                    parentProduct: (0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE
                });
                return;
            }
            if ((0, $5JRMI.TownsquareProjectAri).check(ari)) {
                openAtlasPreviewPanel({
                    url: url,
                    ari: ari,
                    name: "Project",
                    parentProduct: (0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE
                });
                return;
            }
            if ((0, $b8JCF.JiraIssueAri).check(ari)) {
                openAtlasPreviewPanel({
                    url: url,
                    ari: ari,
                    name: "Jira Work Item",
                    parentProduct: (0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE
                });
                return;
            }
            if ((0, $eMqrF.IdentityTeamAri).check(ari)) {
                openAtlasPreviewPanel({
                    url: url,
                    ari: ari,
                    name: "Team",
                    parentProduct: (0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE
                });
                return;
            }
        };
        t1 = {
            open: open
        };
        $[1] = cardContext;
        $[2] = openAtlasPreviewPanel;
        $[3] = openConfluencePagePreviewPanel;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { openPreviewPanel: openAtlasPreviewPanel } = (0, $a7dbab6e358b50cb$export$70bcacea0b970dee)((0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE, cloudId, {
        supportedObjects: (0, $27fJD.ALL_SUPPORTED_OBJECTS)
    });
    const { openConfluencePagePreviewPanel: openConfluencePagePreviewPanel } = (0, $1DfVr.useConfluencePagePreviewPanel)((0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE, cloudId);
    const cardContext = (0, $eIleF.useSmartCardContext)();
    const open = ({ url: url, ari: ari, panelData: panelData })=>{
        let resolvedUrl = url;
        // Only resolve when url is Confluence short links
        if (url.includes('/wiki/x/') && cardContext?.value?.store) {
            const cardState = cardContext.value.store.getState()[url];
            if (cardState?.details) resolvedUrl = $88a4e0a84f25d5c3$var$resolveConfluencePreviewPanelUrl(url, cardState.details);
        }
        const name = (0, $k4HRJ.AnyAri).parse(ari).resourceType;
        const formattedName = name.charAt(0).toUpperCase() + name.slice(1);
        if ((0, $eToX6.isInIframe)() && $88a4e0a84f25d5c3$var$hasPreviewPanelsParam()) {
            // Post message to parent frame to open the panel
            window.parent.postMessage({
                type: 'OPEN_PREVIEW_PANEL',
                payload: {
                    url: resolvedUrl,
                    ari: ari,
                    name: formattedName,
                    panelData: panelData
                }
            }, '*');
            return;
        }
        if ((0, $a2xFu.ConfluencePageAri).check(ari)) {
            const urlObj = new URL(resolvedUrl);
            urlObj.searchParams.set('previewPanels', encodeURIComponent((0, $27fJD.ALL_SUPPORTED_OBJECTS).join(',')));
            openConfluencePagePreviewPanel(urlObj.toString(), $88a4e0a84f25d5c3$var$noop, panelData);
            return;
        }
        if ((0, $ixcaU.TownsquareGoalAri).check(ari)) {
            openAtlasPreviewPanel({
                url: url,
                ari: ari,
                name: 'Goal',
                parentProduct: (0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE
            });
            return;
        }
        if ((0, $5JRMI.TownsquareProjectAri).check(ari)) {
            openAtlasPreviewPanel({
                url: url,
                ari: ari,
                name: 'Project',
                parentProduct: (0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE
            });
            return;
        }
        if ((0, $b8JCF.JiraIssueAri).check(ari)) {
            openAtlasPreviewPanel({
                url: url,
                ari: ari,
                name: 'Jira Work Item',
                parentProduct: (0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE
            });
            return;
        }
        if ((0, $eMqrF.IdentityTeamAri).check(ari)) {
            openAtlasPreviewPanel({
                url: url,
                ari: ari,
                name: 'Team',
                parentProduct: (0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE
            });
            return;
        }
    };
    return {
        open: open
    };
};
module.exports["useOpenPreviewPanel"] = $88a4e0a84f25d5c3$export$b92594fec494137a;

});

parcelRegister("ixcaU", function(module, exports) {
// src/townsquare/goal/types.ts
var $c06d67ada792527e$export$947838268868cc57 = "townsquare", $c06d67ada792527e$export$935b9c2af9d62e80 = "goal";



var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/townsquare/goal/manifest.ts
var $d7e4c0c5e4ce08d0$var$townsquareGoalAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $c06d67ada792527e$export$947838268868cc57),
    resourceType: (0, $c06d67ada792527e$export$935b9c2af9d62e80),
    resourceIdSlug: "{goalUuid}",
    resourceIdSegmentFormats: {
        goalUuid: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/townsquare/goal/index.ts
var $d7e4c0c5e4ce08d0$export$e45ea1bd9a289a4f = class _TownsquareGoalAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get goalUuid() {
        return this._goalUuid;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $d7e4c0c5e4ce08d0$var$townsquareGoalAriStaticOpts.qualifier,
            platformQualifier: $d7e4c0c5e4ce08d0$var$townsquareGoalAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $d7e4c0c5e4ce08d0$var$townsquareGoalAriStaticOpts.resourceOwner,
            resourceType: $d7e4c0c5e4ce08d0$var$townsquareGoalAriStaticOpts.resourceType,
            resourceId: `${opts.goalUuid}`,
            resourceIdSegmentValues: {
                goalUuid: opts.goalUuid
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $d7e4c0c5e4ce08d0$var$townsquareGoalAriStaticOpts);
        return new _TownsquareGoalAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $d7e4c0c5e4ce08d0$var$townsquareGoalAriStaticOpts);
        return new _TownsquareGoalAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            goalUuid: this.goalUuid
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._goalUuid = opts.resourceIdSegmentValues.goalUuid;
    }
};
module.exports["TownsquareGoalAri"] = $d7e4c0c5e4ce08d0$export$e45ea1bd9a289a4f;

});

parcelRegister("2JrHF", function(module, exports) {
/**
 * @generated SignedSource<<9f3b6029d331f98df13d15b5afa019bb>>
 * @relayHash 091ca68f7601169e905e40631d298f3c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 66851695df93aad26c2ebfaa928f776c2033fe03c674c3b72e0431ba7d3136fc
const $782e281f79312060$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ari"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "goalId",
            "variableName": "ari"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ScalarField",
        "name": "url"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = [
        v7 /*: any*/ ,
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        v3 /*: any*/ 
    ], v9 = {
        "kind": "ScalarField",
        "name": "canEditMetrics"
    }, v10 = {
        "kind": "ScalarField",
        "name": "canRemoveLinkedGoals"
    }, v11 = {
        "kind": "ScalarField",
        "name": "canCreateUpdates"
    }, v12 = {
        "kind": "ScalarField",
        "name": "canAddLinkedProjects"
    }, v13 = {
        "kind": "ScalarField",
        "name": "uuid"
    }, v14 = [
        v5 /*: any*/ ,
        v1 /*: any*/ 
    ], v15 = [
        v1 /*: any*/ 
    ], v16 = {
        "kind": "InlineFragment",
        "selections": v15 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v17 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "value"
    }, v19 = [
        v18 /*: any*/ 
    ], v20 = {
        "kind": "InlineFragment",
        "selections": v19 /*: any*/ ,
        "type": "TownsquareGoalTypeCustomName"
    }, v21 = {
        "kind": "ScalarField",
        "name": "messageId"
    }, v22 = {
        "kind": "ScalarField",
        "name": "defaultValue"
    }, v23 = {
        "kind": "InlineFragment",
        "selections": [
            v21 /*: any*/ ,
            v22 /*: any*/ 
        ],
        "type": "TownsquareLocalizationField"
    }, v24 = {
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            v20 /*: any*/ ,
            v23 /*: any*/ 
        ]
    }, v25 = {
        "kind": "ScalarField",
        "name": "kind"
    }, v26 = {
        "kind": "ScalarField",
        "name": "state"
    }, v27 = [
        v18 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "score"
        }
    ], v28 = {
        "concreteType": "TownsquareStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": v27 /*: any*/ 
    }, v29 = {
        "kind": "ScalarField",
        "name": "scoringMode"
    }, v30 = {
        "kind": "ScalarField",
        "name": "isArchived"
    }, v31 = {
        "concreteType": "TownsquareGoalTypeIcon",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
            v5 /*: any*/ 
        ]
    }, v32 = {
        "kind": "LinkedField",
        "name": "namePlural",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v19 /*: any*/ ,
                "type": "TownsquareGoalTypeCustomNamePlural"
            },
            v23 /*: any*/ 
        ]
    }, v33 = {
        "kind": "ScalarField",
        "name": "percentage"
    }, v34 = {
        "kind": "ScalarField",
        "name": "type"
    }, v35 = {
        "concreteType": "TownsquareGoalProgress",
        "kind": "LinkedField",
        "name": "progress",
        "plural": false,
        "selections": [
            v33 /*: any*/ ,
            v34 /*: any*/ 
        ]
    }, v36 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v37 = {
        "kind": "ScalarField",
        "name": "archived"
    }, v38 = {
        "kind": "ScalarField",
        "name": "externalEntityId"
    }, v39 = {
        "kind": "ScalarField",
        "name": "source"
    }, v40 = {
        "kind": "ScalarField",
        "name": "time"
    }, v41 = {
        "concreteType": "TownsquareMetricValue",
        "kind": "LinkedField",
        "name": "latestValue",
        "plural": false,
        "selections": [
            v40 /*: any*/ ,
            v1 /*: any*/ 
        ]
    }, v42 = {
        "kind": "Literal",
        "name": "first",
        "value": 100
    }, v43 = {
        "concreteType": "TownsquareGoalState",
        "kind": "LinkedField",
        "name": "newState",
        "plural": false,
        "selections": v27 /*: any*/ 
    }, v44 = {
        "args": [
            v42 /*: any*/ ,
            {
                "kind": "Literal",
                "name": "sort",
                "value": [
                    "TIME_ASC"
                ]
            }
        ],
        "concreteType": "TownsquareMetricValueConnection",
        "kind": "LinkedField",
        "name": "values",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareMetricValueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "TownsquareMetricValue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v18 /*: any*/ ,
                            v40 /*: any*/ ,
                            {
                                "kind": "LinkedField",
                                "name": "origin",
                                "plural": false,
                                "selections": [
                                    v7 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "concreteType": "TownsquareGoalUpdate",
                                                "kind": "LinkedField",
                                                "name": "goalUpdate",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "TownsquareGoal",
                                                        "kind": "LinkedField",
                                                        "name": "goal",
                                                        "plural": false,
                                                        "selections": v15 /*: any*/ 
                                                    },
                                                    v43 /*: any*/ ,
                                                    v1 /*: any*/ 
                                                ]
                                            }
                                        ],
                                        "type": "TownsquareFromGoalUpdate"
                                    }
                                ]
                            },
                            v1 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "storageKey": "values(first:100,sort:[\"TIME_ASC\"])"
    }, v45 = [
        v18 /*: any*/ ,
        v1 /*: any*/ 
    ], v46 = {
        "concreteType": "TownsquareMetricValue",
        "kind": "LinkedField",
        "name": "snapshotValue",
        "plural": false,
        "selections": v45 /*: any*/ 
    }, v47 = {
        "kind": "ScalarField",
        "name": "startValue"
    }, v48 = {
        "kind": "ScalarField",
        "name": "targetValue"
    }, v49 = {
        "concreteType": "TownsquareMetricTargetConnection",
        "kind": "LinkedField",
        "name": "metricTargets",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareMetricTargetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "TownsquareMetricTarget",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            {
                                "concreteType": "TownsquareMetric",
                                "kind": "LinkedField",
                                "name": "metric",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ ,
                                    v2 /*: any*/ ,
                                    v34 /*: any*/ ,
                                    v36 /*: any*/ ,
                                    v37 /*: any*/ ,
                                    v38 /*: any*/ 
                                ]
                            },
                            v46 /*: any*/ ,
                            v47 /*: any*/ ,
                            v48 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v50 = {
        "concreteType": "TownsquareGoalType",
        "kind": "LinkedField",
        "name": "goalType",
        "plural": false,
        "selections": [
            v31 /*: any*/ ,
            v1 /*: any*/ 
        ]
    }, v51 = {
        "kind": "LinkedField",
        "name": "owner",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            v1 /*: any*/ 
        ]
    }, v52 = {
        "concreteType": "TownsquareTargetDateRange",
        "kind": "LinkedField",
        "name": "dateRange",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "start"
            },
            {
                "kind": "ScalarField",
                "name": "end"
            }
        ]
    }, v53 = {
        "concreteType": "TownsquareTargetDate",
        "kind": "LinkedField",
        "name": "targetDate",
        "plural": false,
        "selections": [
            v52 /*: any*/ 
        ]
    }, v54 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 30
        }
    ], v55 = {
        "kind": "ScalarField",
        "name": "missedUpdate"
    }, v56 = {
        "kind": "ScalarField",
        "name": "updateType"
    }, v57 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v58 = {
        "kind": "ScalarField",
        "name": "editDate"
    }, v59 = {
        "kind": "ScalarField",
        "name": "creationDate"
    }, v60 = {
        "args": v54 /*: any*/ ,
        "concreteType": "TownsquareGoalUpdateConnection",
        "kind": "LinkedField",
        "name": "updates",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareGoalUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "TownsquareGoalUpdate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v55 /*: any*/ ,
                            v56 /*: any*/ ,
                            v57 /*: any*/ ,
                            v58 /*: any*/ ,
                            v59 /*: any*/ ,
                            v1 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "storageKey": "updates(first:30)"
    }, v61 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 200
        }
    ], v62 = {
        "concreteType": "TownsquareIconURIs",
        "kind": "LinkedField",
        "name": "iconUrl",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareThemeURIs",
                "kind": "LinkedField",
                "name": "roundedSquare",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "dark"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "light"
                    }
                ]
            }
        ]
    }, v63 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v64 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v65 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v66 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            v64 /*: any*/ ,
            v65 /*: any*/ 
        ]
    }, v67 = {
        "args": v61 /*: any*/ ,
        "handle": "connection",
        "key": "GoalContentProjects_projects",
        "kind": "LinkedHandle",
        "name": "projects"
    }, v68 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        }
    ], v69 = {
        "concreteType": "TownsquareGoalProgress",
        "kind": "LinkedField",
        "name": "progress",
        "plural": false,
        "selections": [
            v33 /*: any*/ 
        ]
    }, v70 = {
        "concreteType": "TownsquareMetricValue",
        "kind": "LinkedField",
        "name": "newValue",
        "plural": false,
        "selections": v45 /*: any*/ 
    }, v71 = {
        "kind": "ScalarField",
        "name": "description"
    }, v72 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        v71 /*: any*/ 
    ], v73 = [
        v42 /*: any*/ 
    ], v74 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v75 = [
        {
            "kind": "ScalarField",
            "name": "label"
        }
    ], v76 = [
        v7 /*: any*/ ,
        v3 /*: any*/ ,
        v2 /*: any*/ ,
        v1 /*: any*/ 
    ], v77 = {
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": v76 /*: any*/ 
    }, v78 = {
        "kind": "LinkedField",
        "name": "lastEditedBy",
        "plural": false,
        "selections": v76 /*: any*/ 
    }, v79 = {
        "kind": "ScalarField",
        "name": "lastEditedDate"
    }, v80 = {
        "concreteType": "TownsquareCommentConnection",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareCommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "TownsquareComment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            {
                                "kind": "LinkedField",
                                "name": "creator",
                                "plural": false,
                                "selections": [
                                    v7 /*: any*/ ,
                                    v2 /*: any*/ ,
                                    v1 /*: any*/ ,
                                    v74 /*: any*/ ,
                                    v3 /*: any*/ 
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "commentText"
                            },
                            v58 /*: any*/ ,
                            v59 /*: any*/ 
                        ]
                    }
                ]
            },
            v17 /*: any*/ 
        ]
    }, v81 = [
        {
            "kind": "InlineFragment",
            "selections": [
                v57 /*: any*/ ,
                v71 /*: any*/ ,
                v77 /*: any*/ ,
                v78 /*: any*/ ,
                v59 /*: any*/ ,
                v79 /*: any*/ 
            ],
            "type": "TownsquareHighlight",
            "abstractKey": "__isTownsquareHighlight"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "GoalPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v4 /*: any*/ ,
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "goals_byId",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v5 /*: any*/ ,
                            v6 /*: any*/ ,
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalFocusAreas"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalPanelTitleField"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalStatusField"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalType"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalOwner"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalMetrics"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalTargetDate"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ParentGoal"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "SubGoals"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalTags"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalFollowers"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalStartDate"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalActions"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalTeams"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalCustomFields"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalUpdateComposerCreate"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "goals_byId"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "ari",
                            "variableName": "ari"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "GoalPanelTabs"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "GoalPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": v8 /*: any*/ 
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "goals_byId",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "concreteType": "TownsquareGoalCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddLinkedFocusAreas"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveLinkedFocusAreas"
                                },
                                {
                                    "concreteType": "TownsquareGoalAppCapabilities",
                                    "kind": "LinkedField",
                                    "name": "apps",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareFocusAppCapabilities",
                                            "kind": "LinkedField",
                                            "name": "focus",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canViewFocusAreas"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditMetadata"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditStatus"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canManageOwnership"
                                },
                                v9 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditTargetDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddLinkedGoals"
                                },
                                v10 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddTags"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveTags"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditStartDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canArchiveGoal"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveTeams"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddTeams"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditCustomFields"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canCommentOnGoal"
                                },
                                v11 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditUpdates"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canCommentOnUpdates"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveLinkedProjects"
                                },
                                v12 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "canDeleteUpdates"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddLinkedWorkItems"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveLinkedWorkItems"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddJiraAlignItems"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveJiraAlignItems"
                                }
                            ]
                        },
                        {
                            "concreteType": "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseConnection",
                            "kind": "LinkedField",
                            "name": "focusAreas",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "userPermissions"
                                                        },
                                                        v2 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "concreteType": "MercuryFocusAreaStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": v14 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "MercuryFocusAreaHealth",
                                                            "kind": "LinkedField",
                                                            "name": "health",
                                                            "plural": false,
                                                            "selections": v14 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "MercuryFocusArea"
                                                },
                                                v16 /*: any*/ 
                                            ]
                                        },
                                        v1 /*: any*/ 
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareGoalIcon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "appearance"
                                }
                            ]
                        },
                        v2 /*: any*/ ,
                        {
                            "concreteType": "TownsquareGoalType",
                            "kind": "LinkedField",
                            "name": "goalType",
                            "plural": false,
                            "selections": [
                                v24 /*: any*/ ,
                                v1 /*: any*/ ,
                                v25 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareGoalType",
                                    "kind": "LinkedField",
                                    "name": "successMeasure",
                                    "plural": false,
                                    "selections": [
                                        v26 /*: any*/ ,
                                        v1 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v28 /*: any*/ ,
                        v29 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "canPostUpdate"
                        },
                        v30 /*: any*/ ,
                        {
                            "concreteType": "TownsquareGoalType",
                            "kind": "LinkedField",
                            "name": "goalType",
                            "plural": false,
                            "selections": [
                                v31 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "name",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v22 /*: any*/ ,
                                                v21 /*: any*/ 
                                            ],
                                            "type": "TownsquareLocalizationField"
                                        }
                                    ]
                                },
                                v1 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareGoalType",
                                    "kind": "LinkedField",
                                    "name": "successMeasure",
                                    "plural": false,
                                    "selections": [
                                        v24 /*: any*/ ,
                                        v32 /*: any*/ ,
                                        v1 /*: any*/ ,
                                        v26 /*: any*/ 
                                    ]
                                },
                                v25 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": v8 /*: any*/ 
                        },
                        v35 /*: any*/ ,
                        {
                            "concreteType": "TownsquareMetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareMetricTargetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareMetricTarget",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareMetric",
                                                    "kind": "LinkedField",
                                                    "name": "metric",
                                                    "plural": false,
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v34 /*: any*/ ,
                                                        v36 /*: any*/ ,
                                                        v37 /*: any*/ ,
                                                        v38 /*: any*/ ,
                                                        v39 /*: any*/ ,
                                                        v41 /*: any*/ ,
                                                        v44 /*: any*/ 
                                                    ]
                                                },
                                                v46 /*: any*/ ,
                                                v47 /*: any*/ ,
                                                v48 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "subGoals",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareGoal",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v35 /*: any*/ ,
                                                v1 /*: any*/ ,
                                                v30 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareGoalType",
                                                    "kind": "LinkedField",
                                                    "name": "goalType",
                                                    "plural": false,
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        v1 /*: any*/ 
                                                    ]
                                                },
                                                v49 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v28 /*: any*/ ,
                                                v2 /*: any*/ ,
                                                v50 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareGoalCapabilities",
                                                    "kind": "LinkedField",
                                                    "name": "capabilities",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                },
                                                v51 /*: any*/ ,
                                                v53 /*: any*/ ,
                                                v60 /*: any*/ ,
                                                v29 /*: any*/ ,
                                                {
                                                    "args": v61 /*: any*/ ,
                                                    "concreteType": "TownsquareProjectConnection",
                                                    "kind": "LinkedField",
                                                    "name": "projects",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareProjectEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareProject",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v1 /*: any*/ ,
                                                                        v2 /*: any*/ ,
                                                                        v6 /*: any*/ ,
                                                                        v62 /*: any*/ ,
                                                                        v7 /*: any*/ 
                                                                    ]
                                                                },
                                                                v63 /*: any*/ ,
                                                                v7 /*: any*/ 
                                                            ]
                                                        },
                                                        v66 /*: any*/ ,
                                                        v17 /*: any*/ 
                                                    ],
                                                    "storageKey": "projects(first:200)"
                                                },
                                                v67 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareGoalCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        },
                        {
                            "args": v68 /*: any*/ ,
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "successMeasures",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareGoal",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v69 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareGoalType",
                                                    "kind": "LinkedField",
                                                    "name": "goalType",
                                                    "plural": false,
                                                    "selections": [
                                                        v24 /*: any*/ ,
                                                        v32 /*: any*/ ,
                                                        v1 /*: any*/ ,
                                                        v31 /*: any*/ 
                                                    ]
                                                },
                                                v1 /*: any*/ ,
                                                v30 /*: any*/ ,
                                                v2 /*: any*/ ,
                                                v28 /*: any*/ ,
                                                v51 /*: any*/ ,
                                                v53 /*: any*/ ,
                                                {
                                                    "args": v54 /*: any*/ ,
                                                    "concreteType": "TownsquareGoalUpdateConnection",
                                                    "kind": "LinkedField",
                                                    "name": "updates",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareGoalUpdateEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoalUpdate",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v55 /*: any*/ ,
                                                                        v56 /*: any*/ ,
                                                                        v57 /*: any*/ ,
                                                                        v58 /*: any*/ ,
                                                                        v59 /*: any*/ ,
                                                                        v1 /*: any*/ ,
                                                                        v43 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "TownsquareGoalMetricUpdateConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "metricUpdate",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "TownsquareGoalMetricUpdateEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "TownsquareGoalMetricUpdate",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "TownsquareMetric",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "metric",
                                                                                                    "plural": false,
                                                                                                    "selections": v15 /*: any*/ 
                                                                                                },
                                                                                                v70 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "updates(first:30)"
                                                },
                                                v29 /*: any*/ ,
                                                v37 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareMetricTargetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "metricTargets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareMetricTargetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareMetricTarget",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareMetric",
                                                                            "kind": "LinkedField",
                                                                            "name": "metric",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                v36 /*: any*/ ,
                                                                                v2 /*: any*/ ,
                                                                                v1 /*: any*/ ,
                                                                                v44 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v48 /*: any*/ ,
                                                                        v46 /*: any*/ ,
                                                                        v1 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareGoalCapabilities",
                                                    "kind": "LinkedField",
                                                    "name": "capabilities",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v7 /*: any*/ 
                                    ]
                                }
                            ],
                            "storageKey": "successMeasures(first:50)"
                        },
                        {
                            "concreteType": "TownsquareTargetDate",
                            "kind": "LinkedField",
                            "name": "targetDate",
                            "plural": false,
                            "selections": [
                                v52 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "confidence"
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareGoal",
                            "kind": "LinkedField",
                            "name": "parentGoal",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v1 /*: any*/ ,
                                v35 /*: any*/ ,
                                v49 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareStatus",
                                    "kind": "LinkedField",
                                    "name": "status",
                                    "plural": false,
                                    "selections": v19 /*: any*/ 
                                },
                                v2 /*: any*/ ,
                                v50 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareGoalCapabilities",
                                    "kind": "LinkedField",
                                    "name": "capabilities",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareTagConnection",
                            "kind": "LinkedField",
                            "name": "tags",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareTagEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareTag",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                v2 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "usageCount"
                                                },
                                                v71 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        v65 /*: any*/ ,
                                        v64 /*: any*/ 
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareUserConnection",
                            "kind": "LinkedField",
                            "name": "watchers",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "count"
                                },
                                {
                                    "concreteType": "TownsquareUserEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v1 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v2 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "startDate"
                        },
                        v59 /*: any*/ ,
                        {
                            "concreteType": "TownsquareGoalTeamConnection",
                            "kind": "LinkedField",
                            "name": "teams",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalTeamEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "canRemove"
                                        },
                                        {
                                            "concreteType": "TeamV2",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "displayName"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "smallAvatarImageUrl"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isVerified"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "profileUrl"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareCustomFieldConnection",
                            "kind": "LinkedField",
                            "name": "customFields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareCustomFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v72 /*: any*/ ,
                                                                    "type": "TownsquareTextCustomFieldDefinition"
                                                                },
                                                                v16 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                                            "kind": "LinkedField",
                                                            "name": "value",
                                                            "plural": false,
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                {
                                                                    "alias": "textValue",
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "TownsquareTextCustomField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v72 /*: any*/ ,
                                                                    "type": "TownsquareNumberCustomFieldDefinition"
                                                                },
                                                                v16 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TownsquareCustomFieldNumberSavedValueNode",
                                                            "kind": "LinkedField",
                                                            "name": "value",
                                                            "plural": false,
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                {
                                                                    "alias": "numberValue",
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "TownsquareNumberCustomField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v72 /*: any*/ ,
                                                                    "type": "TownsquareUserCustomFieldDefinition"
                                                                },
                                                                v16 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": v73 /*: any*/ ,
                                                            "concreteType": "TownsquareUserConnection",
                                                            "kind": "LinkedField",
                                                            "name": "values",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareUserEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                v1 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isUser"
                                                                                },
                                                                                v2 /*: any*/ ,
                                                                                v3 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v63 /*: any*/ 
                                                                    ]
                                                                },
                                                                v66 /*: any*/ ,
                                                                v17 /*: any*/ 
                                                            ],
                                                            "storageKey": "values(first:100)"
                                                        },
                                                        {
                                                            "args": v73 /*: any*/ ,
                                                            "handle": "connection",
                                                            "key": "CustomFieldUser_values",
                                                            "kind": "LinkedHandle",
                                                            "name": "values"
                                                        }
                                                    ],
                                                    "type": "TownsquareUserCustomField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v1 /*: any*/ ,
                                                                        v2 /*: any*/ ,
                                                                        v71 /*: any*/ ,
                                                                        {
                                                                            "args": v73 /*: any*/ ,
                                                                            "concreteType": "TownsquareCustomFieldTextAllowedValueConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "allowedValues",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "TownsquareCustomFieldTextAllowedValueEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "TownsquareCustomFieldTextAllowedValueNode",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v1 /*: any*/ ,
                                                                                                v18 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "allowedValues(first:100)"
                                                                        }
                                                                    ],
                                                                    "type": "TownsquareTextSelectCustomFieldDefinition"
                                                                },
                                                                v16 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": v73 /*: any*/ ,
                                                            "concreteType": "TownsquareCustomFieldTextSavedValueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "values",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareCustomFieldTextSavedValueEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v1 /*: any*/ ,
                                                                                {
                                                                                    "alias": "selectValue",
                                                                                    "kind": "ScalarField",
                                                                                    "name": "value"
                                                                                },
                                                                                v7 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v63 /*: any*/ 
                                                                    ]
                                                                },
                                                                v66 /*: any*/ ,
                                                                v17 /*: any*/ 
                                                            ],
                                                            "storageKey": "values(first:100)"
                                                        },
                                                        {
                                                            "args": v73 /*: any*/ ,
                                                            "handle": "connection",
                                                            "key": "CustomFieldTextSelect_values",
                                                            "kind": "LinkedHandle",
                                                            "name": "values"
                                                        }
                                                    ],
                                                    "type": "TownsquareTextSelectCustomField"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v54 /*: any*/ ,
                            "concreteType": "TownsquareGoalUpdateConnection",
                            "kind": "LinkedField",
                            "name": "updates",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalUpdateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareGoalUpdate",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                v57 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareUpdateNoteConnection",
                                                    "kind": "LinkedField",
                                                    "name": "updateNotes",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareUpdateNoteEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareUpdateNote",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v57 /*: any*/ ,
                                                                        v71 /*: any*/ ,
                                                                        v1 /*: any*/ ,
                                                                        v37 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v59 /*: any*/ ,
                                                v43 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareGoalMetricUpdateConnection",
                                                    "kind": "LinkedField",
                                                    "name": "metricUpdate",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareGoalMetricUpdateEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoalMetricUpdate",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareMetric",
                                                                            "kind": "LinkedField",
                                                                            "name": "metric",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v1 /*: any*/ ,
                                                                                v2 /*: any*/ ,
                                                                                v34 /*: any*/ ,
                                                                                v36 /*: any*/ ,
                                                                                v37 /*: any*/ ,
                                                                                v39 /*: any*/ ,
                                                                                v41 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v70 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "newStartValue"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "newTargetValue"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "ari"
                                                },
                                                v55 /*: any*/ ,
                                                v56 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "creator",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v1 /*: any*/ ,
                                                        v74 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "newDueDate",
                                                    "plural": false,
                                                    "selections": v75 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "lastEditedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v74 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v1 /*: any*/ 
                                                    ]
                                                },
                                                v58 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareGoalState",
                                                    "kind": "LinkedField",
                                                    "name": "oldState",
                                                    "plural": false,
                                                    "selections": v27 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "oldDueDate",
                                                    "plural": false,
                                                    "selections": v75 /*: any*/ 
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "newTargetDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "newTargetDateConfidence"
                                                },
                                                {
                                                    "concreteType": "TownsquareHighlightConnection",
                                                    "kind": "LinkedField",
                                                    "name": "highlights",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareHighlightEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v57 /*: any*/ ,
                                                                        v71 /*: any*/ ,
                                                                        v7 /*: any*/ ,
                                                                        v1 /*: any*/ ,
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isTownsquareHighlight"
                                                                        },
                                                                        v77 /*: any*/ ,
                                                                        v78 /*: any*/ ,
                                                                        v59 /*: any*/ ,
                                                                        v79 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v17 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareGoal",
                                                    "kind": "LinkedField",
                                                    "name": "goal",
                                                    "plural": false,
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        {
                                                            "concreteType": "TownsquareGoalType",
                                                            "kind": "LinkedField",
                                                            "name": "goalType",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoalType",
                                                                    "kind": "LinkedField",
                                                                    "name": "successMeasure",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v24 /*: any*/ ,
                                                                        v32 /*: any*/ ,
                                                                        v1 /*: any*/ 
                                                                    ]
                                                                },
                                                                v1 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TownsquareGoalConnection",
                                                            "kind": "LinkedField",
                                                            "name": "subGoals",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoalEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareGoal",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v1 /*: any*/ ,
                                                                                v2 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                v69 /*: any*/ ,
                                                                                v50 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v51 /*: any*/ ,
                                                                                v53 /*: any*/ ,
                                                                                v60 /*: any*/ ,
                                                                                v29 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "args": v68 /*: any*/ ,
                                                            "concreteType": "TownsquareGoalConnection",
                                                            "kind": "LinkedField",
                                                            "name": "successMeasures",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoalEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareGoal",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v1 /*: any*/ ,
                                                                                v2 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                v69 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "TownsquareGoalType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "goalType",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v24 /*: any*/ ,
                                                                                        v32 /*: any*/ ,
                                                                                        v31 /*: any*/ ,
                                                                                        v1 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v28 /*: any*/ ,
                                                                                v51 /*: any*/ ,
                                                                                v53 /*: any*/ ,
                                                                                v60 /*: any*/ ,
                                                                                v29 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "successMeasures(first:50)"
                                                        },
                                                        {
                                                            "args": v54 /*: any*/ ,
                                                            "concreteType": "TownsquareGoalUpdateConnection",
                                                            "kind": "LinkedField",
                                                            "name": "updates",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoalUpdateEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareGoalUpdate",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v1 /*: any*/ ,
                                                                                v57 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "TownsquareUpdateNoteConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "updateNotes",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "TownsquareUpdateNoteEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "TownsquareUpdateNote",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v57 /*: any*/ ,
                                                                                                        v71 /*: any*/ ,
                                                                                                        v1 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "updates(first:30)"
                                                        },
                                                        {
                                                            "concreteType": "TownsquareMetricTargetConnection",
                                                            "kind": "LinkedField",
                                                            "name": "metricTargets",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareMetricTargetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareMetricTarget",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "TownsquareMetric",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "metric",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v1 /*: any*/ ,
                                                                                        v37 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v1 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v80 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v17 /*: any*/ 
                            ],
                            "storageKey": "updates(first:30)"
                        },
                        v71 /*: any*/ ,
                        v80 /*: any*/ ,
                        v37 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "canEditUpdate"
                        },
                        {
                            "args": v61 /*: any*/ ,
                            "concreteType": "TownsquareProjectConnection",
                            "kind": "LinkedField",
                            "name": "projects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v63 /*: any*/ ,
                                        {
                                            "concreteType": "TownsquareProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v1 /*: any*/ ,
                                                v2 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v62 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v66 /*: any*/ ,
                                v17 /*: any*/ 
                            ],
                            "storageKey": "projects(first:200)"
                        },
                        v67 /*: any*/ ,
                        {
                            "concreteType": "TownsquareHighlightConnection",
                            "kind": "LinkedField",
                            "name": "highlights",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareHighlightEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v81 /*: any*/ ,
                                                    "type": "TownsquareLearning"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v81 /*: any*/ ,
                                                    "type": "TownsquareRisk"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v81 /*: any*/ ,
                                                    "type": "TownsquareDecision"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "args": v61 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseConnection",
                            "kind": "LinkedField",
                            "name": "workItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v57 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "webUrl"
                                                        }
                                                    ],
                                                    "type": "JiraIssue"
                                                },
                                                v16 /*: any*/ 
                                            ]
                                        },
                                        v63 /*: any*/ ,
                                        v1 /*: any*/ 
                                    ]
                                },
                                v66 /*: any*/ ,
                                v17 /*: any*/ 
                            ],
                            "storageKey": "workItems(first:200)"
                        },
                        {
                            "args": v61 /*: any*/ ,
                            "handle": "connection",
                            "key": "GoalContentJira_workItems",
                            "kind": "LinkedHandle",
                            "name": "workItems"
                        },
                        {
                            "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectConnection",
                            "kind": "LinkedField",
                            "name": "jiraAlignItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "mercuryProjectName"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "mercuryProjectUrl"
                                                        }
                                                    ],
                                                    "type": "JiraAlignAggProject"
                                                },
                                                v16 /*: any*/ 
                                            ]
                                        },
                                        v1 /*: any*/ 
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectConnection",
                            "kind": "LinkedField",
                            "name": "jiraAlignItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v1 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "66851695df93aad26c2ebfaa928f776c2033fe03c674c3b72e0431ba7d3136fc",
            "metadata": {},
            "name": "GoalPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$782e281f79312060$var$node.hash = "76d2216daae10b2020d305d258bd5628";
var $782e281f79312060$export$2e2bcd8739ae039 = $782e281f79312060$var$node;
module.exports["default"] = $782e281f79312060$export$2e2bcd8739ae039;

});

parcelRegister("8CsnF", function(module, exports) {

let $6467e327c89e1d15$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6467e327c89e1d15$var$load("h3ABO"),
    $6467e327c89e1d15$var$load("lXGg9"),
    $6467e327c89e1d15$var$load("hy3sK"),
    $6467e327c89e1d15$var$load("aeEUI"),
    $6467e327c89e1d15$var$load("biF4A"),
    $6467e327c89e1d15$var$load("dDnlz"),
    $6467e327c89e1d15$var$load("jryxA"),
    $6467e327c89e1d15$var$load("dWZbK"),
    $6467e327c89e1d15$var$load("2YffH"),
    $6467e327c89e1d15$var$load("5Y2To"),
    $6467e327c89e1d15$var$load("lNb0L"),
    $6467e327c89e1d15$var$load("bQUGu"),
    $6467e327c89e1d15$var$load("lCT7Q"),
    $6467e327c89e1d15$var$load("47RmW"),
    $6467e327c89e1d15$var$load("8NOg5"),
    $6467e327c89e1d15$var$load("2nTw0"),
    $6467e327c89e1d15$var$load("R7cS6"),
    $6467e327c89e1d15$var$load("h9Ed7"),
    $6467e327c89e1d15$var$load("eBRUf"),
    $6467e327c89e1d15$var$load("d63le"),
    $6467e327c89e1d15$var$load("l8GL7"),
    $6467e327c89e1d15$var$load("gVbhn"),
    $6467e327c89e1d15$var$load("ew3vp"),
    $6467e327c89e1d15$var$load("4F6Xw"),
    $6467e327c89e1d15$var$load("lkOIY"),
    $6467e327c89e1d15$var$load("9L3cI"),
    $6467e327c89e1d15$var$load("eBY1U"),
    $6467e327c89e1d15$var$load("dUz9k"),
    $6467e327c89e1d15$var$load("aowzi"),
    $6467e327c89e1d15$var$load("7PE6o"),
    $6467e327c89e1d15$var$load("3EXzu"),
    $6467e327c89e1d15$var$load("2XikM"),
    $6467e327c89e1d15$var$load("8Q66p"),
    $6467e327c89e1d15$var$load("aJ9z1"),
    $6467e327c89e1d15$var$load("glvWr"),
    $6467e327c89e1d15$var$load("eY3St"),
    $6467e327c89e1d15$var$load("bkd4T"),
    $6467e327c89e1d15$var$load("hshEG"),
    $6467e327c89e1d15$var$load("5CdWD"),
    $6467e327c89e1d15$var$load("deebc"),
    $6467e327c89e1d15$var$load("jTaSF"),
    $6467e327c89e1d15$var$load("9YBgR"),
    $6467e327c89e1d15$var$load("7ZIlR"),
    $6467e327c89e1d15$var$load("855o0"),
    $6467e327c89e1d15$var$load("8MfZE"),
    $6467e327c89e1d15$var$load("6wr18"),
    $6467e327c89e1d15$var$load("kjZZD"),
    $6467e327c89e1d15$var$load("9ZAzg"),
    $6467e327c89e1d15$var$load("kJSYP"),
    $6467e327c89e1d15$var$load("Wowvf"),
    $6467e327c89e1d15$var$load("kHOMt"),
    $6467e327c89e1d15$var$load("dRpV3"),
    $6467e327c89e1d15$var$load("ffEVr"),
    $6467e327c89e1d15$var$load("dTsOE"),
    $6467e327c89e1d15$var$load("hhss7"),
    $6467e327c89e1d15$var$load("8joP2"),
    $6467e327c89e1d15$var$load("8k5x9"),
    $6467e327c89e1d15$var$load("gZGoR"),
    $6467e327c89e1d15$var$load("iqKwT"),
    $6467e327c89e1d15$var$load("kULV9"),
    $6467e327c89e1d15$var$load("7EorR"),
    $6467e327c89e1d15$var$load("kUbUu"),
    $6467e327c89e1d15$var$load("aIokC")
]).then(()=>parcelRequire('jsjFl'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("7MBP8", function(module, exports) {

let $5aaa5b208bfed369$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5aaa5b208bfed369$var$load("jryxA"),
    $5aaa5b208bfed369$var$load("dWZbK"),
    $5aaa5b208bfed369$var$load("kULV9"),
    $5aaa5b208bfed369$var$load("8UKe0"),
    $5aaa5b208bfed369$var$load("5pvpJ"),
    $5aaa5b208bfed369$var$load("dYtBN"),
    $5aaa5b208bfed369$var$load("kNV5Y"),
    $5aaa5b208bfed369$var$load("6wr18"),
    $5aaa5b208bfed369$var$load("kjZZD"),
    $5aaa5b208bfed369$var$load("9ZAzg"),
    $5aaa5b208bfed369$var$load("kJSYP"),
    $5aaa5b208bfed369$var$load("Wowvf"),
    $5aaa5b208bfed369$var$load("dRpV3"),
    $5aaa5b208bfed369$var$load("ffEVr"),
    $5aaa5b208bfed369$var$load("dTsOE"),
    $5aaa5b208bfed369$var$load("hhss7"),
    $5aaa5b208bfed369$var$load("gZGoR"),
    $5aaa5b208bfed369$var$load("iqKwT"),
    $5aaa5b208bfed369$var$load("7EorR"),
    $5aaa5b208bfed369$var$load("kUbUu"),
    $5aaa5b208bfed369$var$load("1SiOe")
]).then(()=>parcelRequire('4bE2r'));

});

parcelRegister("fff9r", function(module, exports) {
/**
 * @generated SignedSource<<89c8f22ae308480433e2794fb41cfb69>>
 * @relayHash 10b74b82b02dc58145c3bdf7a616fe1b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 15c02b13522f665d9ebe3918e343d22e0c74c739b29172342fe90b696205c33b
const $4526c1a589f93175$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ari"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isProjectNativeIntegrationEnabled"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v4 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "projectId",
            "variableName": "ari"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "url"
    }, v7 = [
        v1 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "canEditMembers"
    }, v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = [
        v9 /*: any*/ ,
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        v3 /*: any*/ 
    ], v11 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isUser"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "AtlassianAccountUserExtendedProfile",
                "kind": "LinkedField",
                "name": "extendedProfile",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jobTitle"
                    }
                ]
            }
        ],
        "type": "AtlassianAccountUser"
    }, v13 = {
        "kind": "ScalarField",
        "name": "count"
    }, v14 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "dark"
    }, v16 = {
        "kind": "ScalarField",
        "name": "light"
    }, v17 = {
        "kind": "ScalarField",
        "name": "description"
    }, v18 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v19 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v20 = {
        "kind": "ScalarField",
        "name": "key"
    }, v21 = {
        "kind": "ScalarField",
        "name": "value"
    }, v22 = [
        v21 /*: any*/ 
    ], v23 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v24 = [
        {
            "concreteType": "TownsquareLinkEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "TownsquareLink",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        v6 /*: any*/ ,
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        v14 /*: any*/ 
    ], v25 = {
        "kind": "ScalarField",
        "name": "uuid"
    }, v26 = [
        v20 /*: any*/ ,
        v1 /*: any*/ 
    ], v27 = {
        "kind": "InlineFragment",
        "selections": v7 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v28 = {
        "kind": "ScalarField",
        "name": "creationDate"
    }, v29 = {
        "kind": "ScalarField",
        "name": "editDate"
    }, v30 = {
        "concreteType": "TownsquareCommentConnection",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareCommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "TownsquareComment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            {
                                "kind": "LinkedField",
                                "name": "creator",
                                "plural": false,
                                "selections": [
                                    v9 /*: any*/ ,
                                    v2 /*: any*/ ,
                                    v1 /*: any*/ ,
                                    v4 /*: any*/ ,
                                    v3 /*: any*/ 
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "commentText"
                            },
                            v29 /*: any*/ ,
                            v28 /*: any*/ 
                        ]
                    }
                ]
            },
            v14 /*: any*/ 
        ]
    }, v31 = [
        {
            "kind": "ScalarField",
            "name": "label"
        }
    ], v32 = [
        v9 /*: any*/ ,
        v3 /*: any*/ ,
        v2 /*: any*/ ,
        v1 /*: any*/ 
    ], v33 = {
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": v32 /*: any*/ 
    }, v34 = {
        "kind": "LinkedField",
        "name": "lastEditedBy",
        "plural": false,
        "selections": v32 /*: any*/ 
    }, v35 = {
        "kind": "ScalarField",
        "name": "lastEditedDate"
    }, v36 = [
        {
            "kind": "InlineFragment",
            "selections": [
                v23 /*: any*/ ,
                v17 /*: any*/ ,
                v33 /*: any*/ ,
                v34 /*: any*/ ,
                v28 /*: any*/ ,
                v35 /*: any*/ 
            ],
            "type": "TownsquareHighlight",
            "abstractKey": "__isTownsquareHighlight"
        }
    ], v37 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        v17 /*: any*/ 
    ], v38 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        }
    ], v39 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v40 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            v19 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v41 = {
        "kind": "ScalarField",
        "name": "webUrl"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ProjectPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v5 /*: any*/ ,
                        "concreteType": "TownsquareProject",
                        "kind": "LinkedField",
                        "name": "projects_byId",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v6 /*: any*/ ,
                            {
                                "kind": "LinkedField",
                                "name": "owner",
                                "plural": false,
                                "selections": v7 /*: any*/ 
                            },
                            {
                                "concreteType": "TownsquareContributorConnection",
                                "kind": "LinkedField",
                                "name": "contributors",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "TownsquareContributorEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "TownsquareContributor",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "userContributor",
                                                        "plural": false,
                                                        "selections": v7 /*: any*/ 
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            v8 /*: any*/ ,
                            {
                                "condition": "isProjectNativeIntegrationEnabled",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "ProjectJiraWork"
                                    }
                                ]
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectPanelHeader"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectTags"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectTargetDate"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectStatusField"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectOwner"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectLinks"
                            },
                            {
                                "condition": "isProjectNativeIntegrationEnabled",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "ProjectWorkTracked"
                                    }
                                ]
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectFocusAreas"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectStartDate"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "RelatedProjects"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectContributesTo"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectContributors"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectFollowers"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectActionsContent"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectPanelTabs"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectCustomFields"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "projects_byId"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ProjectPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "TownsquareProject",
                    "kind": "LinkedField",
                    "name": "projects_byId",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": v10 /*: any*/ 
                        },
                        {
                            "concreteType": "TownsquareContributorConnection",
                            "kind": "LinkedField",
                            "name": "contributors",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareContributorEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareContributor",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "userContributor",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v1 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareTeamContributor",
                                                    "kind": "LinkedField",
                                                    "name": "teamContributor",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareUserConnection",
                                                            "kind": "LinkedField",
                                                            "name": "contributingMembers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareUserEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v9 /*: any*/ ,
                                                                                v4 /*: any*/ ,
                                                                                v1 /*: any*/ ,
                                                                                v11 /*: any*/ ,
                                                                                v2 /*: any*/ ,
                                                                                v3 /*: any*/ ,
                                                                                v12 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v13 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TeamV2",
                                                            "kind": "LinkedField",
                                                            "name": "team",
                                                            "plural": false,
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "displayName"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "smallAvatarImageUrl"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "profileUrl"
                                                                },
                                                                {
                                                                    "concreteType": "TeamMemberConnectionV2",
                                                                    "kind": "LinkedField",
                                                                    "name": "members",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TeamMemberEdgeV2",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "TeamMemberV2",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "member",
                                                                                            "plural": false,
                                                                                            "selections": v10 /*: any*/ 
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v14 /*: any*/ 
                            ]
                        },
                        v8 /*: any*/ ,
                        v2 /*: any*/ ,
                        {
                            "concreteType": "TownsquareProjectCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditMetadata"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditTargetDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditStatus"
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareWorkspace",
                            "kind": "LinkedField",
                            "name": "workspace",
                            "plural": false,
                            "selections": v7 /*: any*/ 
                        },
                        {
                            "concreteType": "TownsquareIconURIs",
                            "kind": "LinkedField",
                            "name": "iconUrl",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareThemeURIs",
                                    "kind": "LinkedField",
                                    "name": "roundedSquare",
                                    "plural": false,
                                    "selections": [
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareTagConnection",
                            "kind": "LinkedField",
                            "name": "tags",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareTagEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareTag",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                v2 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "usageCount"
                                                },
                                                v17 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ 
                                    ]
                                },
                                v14 /*: any*/ 
                            ]
                        },
                        v20 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isArchived"
                        },
                        {
                            "concreteType": "TownsquareProjectState",
                            "kind": "LinkedField",
                            "name": "state",
                            "plural": false,
                            "selections": v22 /*: any*/ 
                        },
                        {
                            "concreteType": "TownsquareTargetDate",
                            "kind": "LinkedField",
                            "name": "dueDate",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareTargetDateRange",
                                    "kind": "LinkedField",
                                    "name": "dateRange",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "start"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "end"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "confidence"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "startDate"
                        },
                        {
                            "concreteType": "TownsquareProjectUpdateConnection",
                            "kind": "LinkedField",
                            "name": "updates",
                            "plural": false,
                            "selections": [
                                v14 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "watcherCount"
                        },
                        {
                            "concreteType": "TownsquareProjectUpdate",
                            "kind": "LinkedField",
                            "name": "latestUserUpdate",
                            "plural": false,
                            "selections": [
                                v23 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareUpdateNoteConnection",
                                    "kind": "LinkedField",
                                    "name": "updateNotes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareUpdateNoteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "TownsquareUpdateNote",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v23 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v1 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v1 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareLinkConnection",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": v24 /*: any*/ 
                        },
                        {
                            "concreteType": "GraphStoreSimplifiedFocusAreaHasProjectInverseConnection",
                            "kind": "LinkedField",
                            "name": "focusAreas",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedFocusAreaHasProjectInverseEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "userPermissions"
                                                        },
                                                        v2 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "concreteType": "MercuryFocusAreaStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "MercuryFocusAreaHealth",
                                                            "kind": "LinkedField",
                                                            "name": "health",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "MercuryFocusArea"
                                                },
                                                v27 /*: any*/ 
                                            ]
                                        },
                                        v1 /*: any*/ 
                                    ]
                                },
                                v14 /*: any*/ 
                            ]
                        },
                        v28 /*: any*/ ,
                        {
                            "concreteType": "TownsquareProjectDependencyConnection",
                            "kind": "LinkedField",
                            "name": "dependencies",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareProjectDependencyEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareProjectDependency",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "linkType"
                                                },
                                                {
                                                    "concreteType": "TownsquareProject",
                                                    "kind": "LinkedField",
                                                    "name": "incomingProject",
                                                    "plural": false,
                                                    "selections": v7 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareProject",
                                                    "kind": "LinkedField",
                                                    "name": "outgoingProject",
                                                    "plural": false,
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "concreteType": "TownsquareIconURIs",
                                                            "kind": "LinkedField",
                                                            "name": "iconUrl",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareThemeURIs",
                                                                    "kind": "LinkedField",
                                                                    "name": "square",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v16 /*: any*/ ,
                                                                        v15 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v14 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "goals",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareGoal",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v2 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareStatus",
                                                    "kind": "LinkedField",
                                                    "name": "status",
                                                    "plural": false,
                                                    "selections": v22 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareGoalType",
                                                    "kind": "LinkedField",
                                                    "name": "goalType",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareGoalTypeIcon",
                                                            "kind": "LinkedField",
                                                            "name": "icon",
                                                            "plural": false,
                                                            "selections": [
                                                                v20 /*: any*/ 
                                                            ]
                                                        },
                                                        v1 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v14 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareUserConnection",
                            "kind": "LinkedField",
                            "name": "watchers",
                            "plural": false,
                            "selections": [
                                v13 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareUserEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v1 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v2 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareProjectDescription",
                            "kind": "LinkedField",
                            "name": "description",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "what"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "why"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "measurement"
                                }
                            ]
                        },
                        v30 /*: any*/ ,
                        {
                            "concreteType": "TownsquareProjectUpdateConnection",
                            "kind": "LinkedField",
                            "name": "updates",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareProjectUpdateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareProjectUpdate",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "ari"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "missedUpdate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "updateType"
                                                },
                                                v23 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "creator",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v1 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "newDueDate",
                                                    "plural": false,
                                                    "selections": v31 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareProjectState",
                                                    "kind": "LinkedField",
                                                    "name": "newState",
                                                    "plural": false,
                                                    "selections": v22 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "lastEditedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v1 /*: any*/ 
                                                    ]
                                                },
                                                v28 /*: any*/ ,
                                                v29 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareProjectState",
                                                    "kind": "LinkedField",
                                                    "name": "oldState",
                                                    "plural": false,
                                                    "selections": v22 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "oldDueDate",
                                                    "plural": false,
                                                    "selections": v31 /*: any*/ 
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "newTargetDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "newTargetDateConfidence"
                                                },
                                                {
                                                    "concreteType": "TownsquareUpdateNoteConnection",
                                                    "kind": "LinkedField",
                                                    "name": "updateNotes",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareUpdateNoteEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareUpdateNote",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v1 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v17 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "archived"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareHighlightConnection",
                                                    "kind": "LinkedField",
                                                    "name": "highlights",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareHighlightEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v23 /*: any*/ ,
                                                                        v17 /*: any*/ ,
                                                                        v9 /*: any*/ ,
                                                                        v1 /*: any*/ ,
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isTownsquareHighlight"
                                                                        },
                                                                        v33 /*: any*/ ,
                                                                        v34 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        v35 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v14 /*: any*/ 
                                                    ]
                                                },
                                                v30 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareHighlightConnection",
                            "kind": "LinkedField",
                            "name": "highlights",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareHighlightEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v36 /*: any*/ ,
                                                    "type": "TownsquareLearning"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v36 /*: any*/ ,
                                                    "type": "TownsquareRisk"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v36 /*: any*/ ,
                                                    "type": "TownsquareDecision"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v14 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareCustomFieldConnection",
                            "kind": "LinkedField",
                            "name": "customFields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareCustomFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v37 /*: any*/ ,
                                                                    "type": "TownsquareTextCustomFieldDefinition"
                                                                },
                                                                v27 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                                            "kind": "LinkedField",
                                                            "name": "value",
                                                            "plural": false,
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                {
                                                                    "alias": "textValue",
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "TownsquareTextCustomField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v37 /*: any*/ ,
                                                                    "type": "TownsquareNumberCustomFieldDefinition"
                                                                },
                                                                v27 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TownsquareCustomFieldNumberSavedValueNode",
                                                            "kind": "LinkedField",
                                                            "name": "value",
                                                            "plural": false,
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                {
                                                                    "alias": "numberValue",
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "TownsquareNumberCustomField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v37 /*: any*/ ,
                                                                    "type": "TownsquareUserCustomFieldDefinition"
                                                                },
                                                                v27 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": v38 /*: any*/ ,
                                                            "concreteType": "TownsquareUserConnection",
                                                            "kind": "LinkedField",
                                                            "name": "values",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareUserEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v9 /*: any*/ ,
                                                                                v1 /*: any*/ ,
                                                                                v11 /*: any*/ ,
                                                                                v2 /*: any*/ ,
                                                                                v3 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v39 /*: any*/ 
                                                                    ]
                                                                },
                                                                v40 /*: any*/ ,
                                                                v14 /*: any*/ 
                                                            ],
                                                            "storageKey": "values(first:100)"
                                                        },
                                                        {
                                                            "args": v38 /*: any*/ ,
                                                            "handle": "connection",
                                                            "key": "CustomFieldUser_values",
                                                            "kind": "LinkedHandle",
                                                            "name": "values"
                                                        }
                                                    ],
                                                    "type": "TownsquareUserCustomField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v1 /*: any*/ ,
                                                                        v2 /*: any*/ ,
                                                                        v17 /*: any*/ ,
                                                                        {
                                                                            "args": v38 /*: any*/ ,
                                                                            "concreteType": "TownsquareCustomFieldTextAllowedValueConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "allowedValues",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "TownsquareCustomFieldTextAllowedValueEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "TownsquareCustomFieldTextAllowedValueNode",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v1 /*: any*/ ,
                                                                                                v21 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "allowedValues(first:100)"
                                                                        }
                                                                    ],
                                                                    "type": "TownsquareTextSelectCustomFieldDefinition"
                                                                },
                                                                v27 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": v38 /*: any*/ ,
                                                            "concreteType": "TownsquareCustomFieldTextSavedValueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "values",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareCustomFieldTextSavedValueEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v1 /*: any*/ ,
                                                                                {
                                                                                    "alias": "selectValue",
                                                                                    "kind": "ScalarField",
                                                                                    "name": "value"
                                                                                },
                                                                                v9 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v39 /*: any*/ 
                                                                    ]
                                                                },
                                                                v40 /*: any*/ ,
                                                                v14 /*: any*/ 
                                                            ],
                                                            "storageKey": "values(first:100)"
                                                        },
                                                        {
                                                            "args": v38 /*: any*/ ,
                                                            "handle": "connection",
                                                            "key": "CustomFieldTextSelect_values",
                                                            "kind": "LinkedHandle",
                                                            "name": "values"
                                                        }
                                                    ],
                                                    "type": "TownsquareTextSelectCustomField"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isProjectNativeIntegrationEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 5
                                        }
                                    ],
                                    "concreteType": "GraphStoreSimplifiedAtlasProjectTrackedOnJiraWorkItemConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedJiraWorkItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "GraphStoreSimplifiedAtlasProjectTrackedOnJiraWorkItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                v41 /*: any*/ ,
                                                                v23 /*: any*/ ,
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "permission",
                                                                            "value": "EDIT_ISSUES"
                                                                        }
                                                                    ],
                                                                    "kind": "ScalarField",
                                                                    "name": "hasProjectPermission",
                                                                    "storageKey": "hasProjectPermission(permission:\"EDIT_ISSUES\")"
                                                                },
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "statusId"
                                                                        },
                                                                        v2 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraStatusCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "statusCategory",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "statusCategoryId"
                                                                                },
                                                                                v2 /*: any*/ ,
                                                                                v1 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v1 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "issueTypeId"
                                                                        },
                                                                        v2 /*: any*/ ,
                                                                        v1 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraIssue"
                                                        },
                                                        v27 /*: any*/ 
                                                    ]
                                                },
                                                v1 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "storageKey": "linkedJiraWorkItems(first:5)"
                                }
                            ]
                        },
                        {
                            "condition": "isProjectNativeIntegrationEnabled",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "workTrackingLinks",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "WORK_TRACKING"
                                        }
                                    ],
                                    "concreteType": "TownsquareLinkConnection",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": v24 /*: any*/ ,
                                    "storageKey": "links(first:1,type:\"WORK_TRACKING\")"
                                },
                                {
                                    "concreteType": "TownsquareFusionDetails",
                                    "kind": "LinkedField",
                                    "name": "fusion",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "synced"
                                        },
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "issue",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v41 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "15c02b13522f665d9ebe3918e343d22e0c74c739b29172342fe90b696205c33b",
            "metadata": {},
            "name": "ProjectPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4526c1a589f93175$var$node.hash = "e65b0c1cff179f718b3db2224d665ed5";
var $4526c1a589f93175$export$2e2bcd8739ae039 = $4526c1a589f93175$var$node;
module.exports["default"] = $4526c1a589f93175$export$2e2bcd8739ae039;

});

parcelRegister("4Io4R", function(module, exports) {

let $36edf2c2c6b0843c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $36edf2c2c6b0843c$var$load("h3ABO"),
    $36edf2c2c6b0843c$var$load("aeEUI"),
    $36edf2c2c6b0843c$var$load("biF4A"),
    $36edf2c2c6b0843c$var$load("dDnlz"),
    $36edf2c2c6b0843c$var$load("jryxA"),
    $36edf2c2c6b0843c$var$load("dWZbK"),
    $36edf2c2c6b0843c$var$load("2YffH"),
    $36edf2c2c6b0843c$var$load("1YtXy"),
    $36edf2c2c6b0843c$var$load("hyzoX"),
    $36edf2c2c6b0843c$var$load("lCT7Q"),
    $36edf2c2c6b0843c$var$load("47RmW"),
    $36edf2c2c6b0843c$var$load("8NOg5"),
    $36edf2c2c6b0843c$var$load("2nTw0"),
    $36edf2c2c6b0843c$var$load("R7cS6"),
    $36edf2c2c6b0843c$var$load("h9Ed7"),
    $36edf2c2c6b0843c$var$load("eBRUf"),
    $36edf2c2c6b0843c$var$load("d63le"),
    $36edf2c2c6b0843c$var$load("l8GL7"),
    $36edf2c2c6b0843c$var$load("gVbhn"),
    $36edf2c2c6b0843c$var$load("b7Mng"),
    $36edf2c2c6b0843c$var$load("ew3vp"),
    $36edf2c2c6b0843c$var$load("lkOIY"),
    $36edf2c2c6b0843c$var$load("9L3cI"),
    $36edf2c2c6b0843c$var$load("eBY1U"),
    $36edf2c2c6b0843c$var$load("dUz9k"),
    $36edf2c2c6b0843c$var$load("aowzi"),
    $36edf2c2c6b0843c$var$load("7PE6o"),
    $36edf2c2c6b0843c$var$load("3EXzu"),
    $36edf2c2c6b0843c$var$load("2XikM"),
    $36edf2c2c6b0843c$var$load("lXGg9"),
    $36edf2c2c6b0843c$var$load("hy3sK"),
    $36edf2c2c6b0843c$var$load("g9CVe"),
    $36edf2c2c6b0843c$var$load("8Q66p"),
    $36edf2c2c6b0843c$var$load("aJ9z1"),
    $36edf2c2c6b0843c$var$load("glvWr"),
    $36edf2c2c6b0843c$var$load("eY3St"),
    $36edf2c2c6b0843c$var$load("bkd4T"),
    $36edf2c2c6b0843c$var$load("hshEG"),
    $36edf2c2c6b0843c$var$load("5CdWD"),
    $36edf2c2c6b0843c$var$load("deebc"),
    $36edf2c2c6b0843c$var$load("jTaSF"),
    $36edf2c2c6b0843c$var$load("9YBgR"),
    $36edf2c2c6b0843c$var$load("7ZIlR"),
    $36edf2c2c6b0843c$var$load("855o0"),
    $36edf2c2c6b0843c$var$load("8MfZE"),
    $36edf2c2c6b0843c$var$load("6wr18"),
    $36edf2c2c6b0843c$var$load("kjZZD"),
    $36edf2c2c6b0843c$var$load("9ZAzg"),
    $36edf2c2c6b0843c$var$load("kJSYP"),
    $36edf2c2c6b0843c$var$load("Wowvf"),
    $36edf2c2c6b0843c$var$load("kHOMt"),
    $36edf2c2c6b0843c$var$load("dRpV3"),
    $36edf2c2c6b0843c$var$load("ffEVr"),
    $36edf2c2c6b0843c$var$load("dTsOE"),
    $36edf2c2c6b0843c$var$load("hhss7"),
    $36edf2c2c6b0843c$var$load("8joP2"),
    $36edf2c2c6b0843c$var$load("8k5x9"),
    $36edf2c2c6b0843c$var$load("gZGoR"),
    $36edf2c2c6b0843c$var$load("iqKwT"),
    $36edf2c2c6b0843c$var$load("kULV9"),
    $36edf2c2c6b0843c$var$load("7EorR"),
    $36edf2c2c6b0843c$var$load("kUbUu"),
    $36edf2c2c6b0843c$var$load("aPnpL")
]).then(()=>parcelRequire('2WJhA'));

});

parcelRegister("i84MD", function(module, exports) {
/**
 * @generated SignedSource<<be9d76f63db93553bbb649b37a6b4c41>>
 * @relayHash 91adf951953bfe64ddb250042a4a0511
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1833329048b99734ed78f2acc837e88e917ff4ae53ed33b16de39b8b3f5a0527
const $b0e79b658ff3836d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "args": [
            {
                "items": [
                    {
                        "kind": "Variable",
                        "name": "cloudIds.0",
                        "variableName": "cloudId"
                    }
                ],
                "kind": "ListValue",
                "name": "cloudIds"
            }
        ],
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "orgId"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "teamPreviewPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        }
                    ]
                },
                v2 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "teamPreviewPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v1 /*: any*/ 
                            ]
                        }
                    ]
                },
                v2 /*: any*/ 
            ]
        },
        "params": {
            "id": "1833329048b99734ed78f2acc837e88e917ff4ae53ed33b16de39b8b3f5a0527",
            "metadata": {},
            "name": "teamPreviewPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b0e79b658ff3836d$var$node.hash = "6b8a5c1e76dd69e5d8daea6919628199";
var $b0e79b658ff3836d$export$2e2bcd8739ae039 = $b0e79b658ff3836d$var$node;
module.exports["default"] = $b0e79b658ff3836d$export$2e2bcd8739ae039;

});

parcelRegister("heXUE", function(module, exports) {

let $c8d237e0d8f9d5c2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c8d237e0d8f9d5c2$var$load("aowzi"),
    $c8d237e0d8f9d5c2$var$load("7PE6o"),
    $c8d237e0d8f9d5c2$var$load("g9CVe"),
    $c8d237e0d8f9d5c2$var$load("jTaSF"),
    $c8d237e0d8f9d5c2$var$load("8joP2"),
    $c8d237e0d8f9d5c2$var$load("8k5x9"),
    $c8d237e0d8f9d5c2$var$load("jryxA"),
    $c8d237e0d8f9d5c2$var$load("dWZbK"),
    $c8d237e0d8f9d5c2$var$load("eVYW1"),
    $c8d237e0d8f9d5c2$var$load("ls0Um"),
    $c8d237e0d8f9d5c2$var$load("020xd"),
    $c8d237e0d8f9d5c2$var$load("eTBsW"),
    $c8d237e0d8f9d5c2$var$load("1oiJ6"),
    $c8d237e0d8f9d5c2$var$load("lPQcc"),
    $c8d237e0d8f9d5c2$var$load("9DLLg"),
    $c8d237e0d8f9d5c2$var$load("jvHRs"),
    $c8d237e0d8f9d5c2$var$load("466mz"),
    $c8d237e0d8f9d5c2$var$load("gWfLJ"),
    $c8d237e0d8f9d5c2$var$load("3GDEr"),
    $c8d237e0d8f9d5c2$var$load("64UoX"),
    $c8d237e0d8f9d5c2$var$load("lidyf"),
    $c8d237e0d8f9d5c2$var$load("hyzoX"),
    $c8d237e0d8f9d5c2$var$load("b7Mng"),
    $c8d237e0d8f9d5c2$var$load("ew3vp"),
    $c8d237e0d8f9d5c2$var$load("31bKg"),
    $c8d237e0d8f9d5c2$var$load("jbxHq"),
    $c8d237e0d8f9d5c2$var$load("9XYQ9"),
    $c8d237e0d8f9d5c2$var$load("4USmq"),
    $c8d237e0d8f9d5c2$var$load("lXGg9"),
    $c8d237e0d8f9d5c2$var$load("hy3sK"),
    $c8d237e0d8f9d5c2$var$load("cSjCJ"),
    $c8d237e0d8f9d5c2$var$load("ht6hk"),
    $c8d237e0d8f9d5c2$var$load("eY3St"),
    $c8d237e0d8f9d5c2$var$load("bkd4T"),
    $c8d237e0d8f9d5c2$var$load("1Y6tF"),
    $c8d237e0d8f9d5c2$var$load("4y6Fp"),
    $c8d237e0d8f9d5c2$var$load("b2FtX"),
    $c8d237e0d8f9d5c2$var$load("dYtBN"),
    $c8d237e0d8f9d5c2$var$load("6wr18"),
    $c8d237e0d8f9d5c2$var$load("kjZZD"),
    $c8d237e0d8f9d5c2$var$load("9ZAzg"),
    $c8d237e0d8f9d5c2$var$load("kJSYP"),
    $c8d237e0d8f9d5c2$var$load("Wowvf"),
    $c8d237e0d8f9d5c2$var$load("kHOMt"),
    $c8d237e0d8f9d5c2$var$load("dRpV3"),
    $c8d237e0d8f9d5c2$var$load("ffEVr"),
    $c8d237e0d8f9d5c2$var$load("dTsOE"),
    $c8d237e0d8f9d5c2$var$load("hhss7"),
    $c8d237e0d8f9d5c2$var$load("gZGoR"),
    $c8d237e0d8f9d5c2$var$load("iqKwT"),
    $c8d237e0d8f9d5c2$var$load("kULV9"),
    $c8d237e0d8f9d5c2$var$load("7EorR"),
    $c8d237e0d8f9d5c2$var$load("kUbUu"),
    $c8d237e0d8f9d5c2$var$load("9SyhI"),
    $c8d237e0d8f9d5c2$var$load("jRc59")
]).then(()=>parcelRequire('eK8NE'));

});

parcelRegister("27fJD", function(module, exports) {

var $a2xFu = parcelRequire("a2xFu");

var $eMqrF = parcelRequire("eMqrF");

var $b8JCF = parcelRequire("b8JCF");

var $ixcaU = parcelRequire("ixcaU");

var $5JRMI = parcelRequire("5JRMI");


var $eToX6 = parcelRequire("eToX6");

const $8d12b9c9b8a8c583$export$cec6f7cb9c99f251 = [
    'jira-issue',
    'confluence-page',
    'identity-team',
    'townsquare-goal',
    'townsquare-project'
];
const $8d12b9c9b8a8c583$export$9e4592d635e5db5b = ({ ari: ari })=>{
    const href = window?.location?.href;
    if (href) {
        const searchParams = new URL(href).searchParams;
        if (searchParams.get('parentProduct')?.toLowerCase() === 'jsm') return false;
        if ((0, $eToX6.isInIframe)() && !(0, $eToX6.hasPreviewPanelIndicators)(searchParams)) return false;
    }
    if ((0, $a2xFu.ConfluencePageAri).check(ari)) return true;
    if ((0, $b8JCF.JiraIssueAri).check(ari)) return true;
    if ((0, $ixcaU.TownsquareGoalAri).check(ari)) return true;
    if ((0, $5JRMI.TownsquareProjectAri).check(ari)) return true;
    if ((0, $eMqrF.IdentityTeamAri).check(ari)) return true;
    return false;
};
module.exports["ALL_SUPPORTED_OBJECTS"] = $8d12b9c9b8a8c583$export$cec6f7cb9c99f251;
module.exports["isPreviewPanelAvailable"] = $8d12b9c9b8a8c583$export$9e4592d635e5db5b;

});


$parcel$global.rlb("8PPsf")
//# sourceMappingURL=FullPageEditorComponent.d1df28ad.js.map
